export const en = {
  Enums: {
    ProcessType: {
      MassCommand: 'Mass Command',
      MassMeterRegistration: 'Mass Meter Import',
      MassMeterEdit: 'Mass Meter Edit',
      ExportBillings: 'Readings Billing',
      ScheduleRecoverMassMemorySmc: 'Scheduled SMC Mass Memory Recovery',
      ScheduledCommand: 'Scheduled Command',
    },
    maxPhaseUnbalanceCurve: 'Max Phase Unbalance Curve',
    AccountStatus: {
      DISABLED: 'Disconnected',
      ACTIVATED: 'Connected',
      NO_RELE: 'No Relay',
      NO_INFORMATION: 'No Information',
      maxPhaseUnbalanceCurve: 'Max Phase Unbalance Curve',
      ALL: 'Everything',
    },
    TicketStatus: {
      Cancelled: 'Canceled',
      CommandTimeOutReached: 'Execution Timeout Reached',
      Executing: 'Executing',
      Failed: 'Failed',
      FailedToContinue: 'Error during processing',
      FailedToStart: 'Failed to initialize',
      Finished: 'Finished',
      Success: 'Executed with Success',
      Interupted: 'Interrupted',
      MiddleWareOffline: 'MiddleWare Offline or Unavailable',
      MiddlewareNotResponding: 'No response from MiddleWare',
      PartiallyFinished: 'Partially Finished',
      Waiting: 'Waiting',
      WaitingScheduleDateTime: 'Waiting for scheduled date and time',
      SystemTimeout: 'System Execution Timeout Reached',
      Timeout: 'Request Timeout Reached',
      OutsideAllowedTime: 'Period not allowed',
    },
    StatusCommand: {
      DATA_BLOCK_UNAVAILABLE: 'Data block unavailable',
      DAT_BLOCK_NUMBER_INVALID: 'Invalid block number!',
      HARDWARE_FAULT: 'Hardware Fault',
      INCOMPLETE: 'Incomplete',
      INCORRECT_KEYS: 'Incorrect Keys',
      INTERRUPTED_BY_COMMISSIONING: 'Interrupted by commissioning',
      INVALID_ITEM: 'Invalid item',
      LONG_GET_ABORTED: 'Get Long Aborted',
      LONG_SET_ABORTED: 'Set Long Aborted',
      METERS_NOT_MATCH_WITH_RECEIVED: 'Invalid meter list',
      NO_LONG_GET_IN_PROGRESS: 'No Get Long in progress',
      NO_LONG_SET_IN_PROGRESS: 'No Set Long in progress',
      OBJECT_CLASS_INCONSISTENT: 'Inconsistent object class',
      OBJECT_UNAVAILABLE: 'Object unavailable',
      OBJECT_UNDEFINED: 'Object undefined',
      OPEN_DOOR: 'Open Door',
      OTHER_REASON: 'Other Reason',
      READ_WRITE_DENIED: 'Read or Write Denied',
      SCOPE_OF_ACCESS_VIOLATED: 'Scope of Access Violated',
      SET_INTERVAL_OF_LONG_OUT_VOLTAGE: 'Configuration of Long Out Event Capture Interval',
      SET_INTERVAL_OF_QEE: 'Configuration of DRP/DRC Capture Interval',
      SET_STANDARD_FROZEN_DATA: 'Configuration of Standard Energy Template',
      SUCESS: 'Executed with Success',
      TEMPORARY_FAILURE: 'Temporary Failure',
      TIMEOUT: 'Execution Timeout Reached',
      SYSTEMTIMEOUT: 'System Timeout Reached',
      TYPE_UNMATCHED: 'Inconsistent Type',
      WAITING: 'Waiting for Response',
      EXECUTING: 'Executing',
      NO_COMISSIONED: 'Commissioning not registered',
      SCHEDULED: 'Scheduled',
      SENT: 'Sent',
      FINISHED: 'Finished',
      CANCELLED: 'Canceled',
      SUCCESS: 'Executed with success',
      COMMUNICATIONERROR: 'Communication error',
      EXECUTIONERROR: 'Execution error',
      INTERNALERROR: 'Internal error',
      INVALID_METERS: 'Invalid meter(s)',
      ACKNOWLEDGMENT: 'Simple acknowledgment',
      INVALID_SCHEMA: 'Invalid request format',
      DATA_UNAVAILABLE: 'Data unavailable',
      NOT_SUPPORTED: 'Functionality not supported',
      INVALIDMETER: 'Invalid meter',
      CUT_AT_IMPROPER_TIME: 'Period not allowed',
    },
    CommandType: {
      DisableCollectiveCut: 'Authorize Door Opening',
      EnableCollectiveCut: 'Disable Door Opening',
      GetQEEIndicator: 'Request Quality Parameters',
      GetVoltageOutLong: 'Request Voltage Out Long Alarm',
      GetVoltageOutShort: 'Request Voltage Out Short Alarm',
      ImportFrozenData: 'Import Energy Totalizers',
      ImportMassMemory: 'Import Mass Memory',
      ImportQEEIndicator: 'Import Quality Parameters',
      ImportVoltageOutAlarm: 'Import Voltage Out Alarms',
      InstantMeasure: 'Request Instant Energy',
      ListMetersSmcSerial: 'Request Meters from SMC',
      MarkAlarmAsRead: 'Mark Alarm as Read',
      MeterAddedToSmc: 'Add meter to smc (System)',
      MeterRemovedFromSmc: 'Remove meter from smc (System)',
      NicReset: 'Reset NIC',
      RecoverEventQeeIndicator: 'Recover Quality Indicators',
      RecoverFrozenData: 'Recover Energy Totalizers',
      RecoverGbtMessage: 'GBT',
      RecoverMassMemory: 'Recover Mass Memory',
      RelayOff: 'Disconnect Relay',
      RelayOn: 'Connect Relay',
      RelayOnAllMetersOfSmc: 'Reconnect all clients',
      RelayStatus: 'Get Relay Status',
      SmiInfoRequest: 'Get meter information',
      RequestDoorStatus: 'Get Collective Cut Status',
      RequestRelayStatusAllSmc: 'Request Relay Status of All Meters',
      Rollback: 'Rollback',
      SendKeyAk: 'Send Authentication Keys to Meters',
      SendKeyEk: 'Send Encryption Keys to Meters',
      GetCellIDAndIP: 'Get Cell ID and IP',
      SetDatetime: 'Set SMC Date and Time',
      SetIntervalOLongOutEvent: 'Configuration of Long Out Event Capture Interval',
      SetIntervalOfQee: 'Configuration of DRP/DRC Capture Interval',
      SetStandardFrozenData: 'Configuration of Standard Energy Template',
      Set_Current: 'Change Cutting Current',
      UpdateDateTime: 'Update Date and Time',
      ReadDateTime: 'Read Date and Time',
      UplinkPeriod: 'Change Uplink Reading Period',
      DoorStatusAbsolute: 'Get Door Status',
      SetSmiVoltage: 'Set Reference Voltage',
      SetDisplayConfiguration: 'Set Display Auto Configuration',
      SetDisplayConfigurationManual: 'Set Display Manual Configuration',
      SetDisplayConfigurationMicromax: 'Set Display Auto Configuration MicroMax',
      SetDisplayConfigurationManualMicromax: 'Set Display Manual Configuration MicroMax',
      GetSmiVoltage: 'Get Reference Voltage',
      MeterRecoverEventQeeIndicator: 'Recover Quality Parameters',
      SetQualityMeasureParams: 'Set Quality Measure Parameters',
      GetQeeBuffer: 'Get Qee Buffer',
      GetEnergyTotalizer: 'Request Active Direct Energy',
      MassRegistration: 'Mass Registration',
      MassEdit: 'Mass Edit',
      ChangeNetworkType: 'Change Network Type',
      GetNetworkType: 'Get Network Type',
      GetNetworkInfo: 'Get Network Info',
      GetHeartBeatCommand: 'Recover Signal Quality',
      ChangeNetworkTech: 'Change Network Technology',
      GetDaylightSavingsEnabled: 'Get Daylight Savings Enabled',
      GetDaylightSavingsEnd: 'Get Daylight Savings End',
      GetDaylightSavingsDeviation: 'Get Daylight Savings Deviation',
      GetDaylightSavingsBegin: 'Get Daylight Savings Begin',
      GetSpecialDaysTable: 'Get Special Days Table',
      SetSpecialDaysTable: 'Add Special Days',
      DeleteSpecialDays: 'Delete special days',
      GetDmrcSwitch: 'Request DMRC and UFER Switch',
      SetDmrcSwitch: 'Set DMRC and UFER Switch',
      SetDayPassiveActivityCalendar: 'Add Passive Day Calendar',
      SetWeekPassiveActivityCalendar: 'Add Passive Week Calendar',
      ActivatePassiveTimeCalendarActivityCalendar: 'Add Activation Time',
      SetDayProfilePassiveCalendarActivityCalendar: 'Add Passive Day Calendar DMRC',
      DrmcSetWeekProfilePassiveCalendarActivityCalendar: 'Add Passive Week Calendar DMRC',
      DrmcGetDayProfilePassiveActivityCalendar: 'Request Passive Day Calendar DMRC',
      DrmcGetActivatePassiveTimeCalendarActivityCalendar:
        'Request Passive Activation Time Calendar DMRC',
      GetActivatePassiveTimeCalendarActivityCalendar: 'Request Passive Activation Time Calendar',
      GetWeekProfilePassiveActivityCalendar: 'Request Passive Week Calendar',
      GetWeekProfileActiveActivityCalendar: 'Request Active Week Calendar',
      GetDayProfileActiveActivityCalendar: 'Request Active Day Calendar',
      GetDayProfilePassiveActivityCalendar: 'Request Passive Day Calendar',
      DrmcGetWeekProfileActiveActivityCalendar: 'Request Active Week Calendar DMRC',
      DrmcGetWeekProfilePassiveActivityCalendar: 'Request Passive Week Calendar DMRC',
      DrmcGetDayProfileActiveActivityCalendar: 'Request Active Day Calendar DMRC',
      DrmcActivatePassiveTimeCalendarActivityCalendar: 'Add Activation Time DMRC',
      SetActivatePassiveCalendarActivityCalendar: 'Set Profile Status DMRC',
      ActivatePassiveCalendarActivityCalendar: 'Set Profile Status',
      SetDaylightSavingsEnabled: 'Set Daylight Savings Enabled',
      SetDaylightSavingsDeviation: 'Set Daylight Savings Deviation',
      SetDaylightSavingsBegin: 'Set Daylight Savings Begin',
      SetDaylightSavingsEnd: 'Set Daylight Savings End',
      GetTaxPage: 'Get Tax Page',
      GetDemandRegisters: 'Get Demand Registers',
      GetGeneralReadingValues: 'Get General Reading Values',
      DeactivateMeter: 'Deactivate Meter',
      AddMeterToGateway: 'Add Meter to Gateway',
      RemoveMeterFromGateway: 'Remove Meter from Gateway',
      ListMetersFromGateway: 'List Meters from Gateway',
      ReadDisplayConfiguration: 'Read Display Configuration',
      ReadDatetime: 'Date and Time Reading',
      GetDailyBilling: 'Get Daily Billing',
      GetLoadProfile: 'Get Load Profile',
      GetFiscalPage: 'Get Fiscal Page',
      ReprocessBilling: 'Reprocess Billing',
      ReprocessCutRelay: 'Reprocess Cut/Reconnect',
      ReprocessDetailUc: 'Reprocess Consumer Unit Details',
      VoltageInterruptionMonthly: 'Read Voltage Interruption Monthly',
      DrpDrcMonthly: 'Request Monthly DRP/DRC',
      DrpDrcCycle: 'Request DRP/DRC Cycle',
      SetTariffConfiguration: 'Set Tariff Type',
      DeviceReset: 'Device Reset',
      RecoverMonitoring: 'Load Profile (Energy + Mass Memory)',
      InfoRequest: 'Read general info',
      RequestConfiguration: 'Read configuration',
      GetBlockSize: 'Get Block Size',
      ImageTransferInitiate: 'Image Transfer Initiate',
      ImageTransferData: 'Image Transfer Data',
      GetFirstBlockNotTransferred: 'Get First Block Not Transferred',
      ImageTransferVerify: 'Image Transfer Verify',
      ImageTransferActivate: 'Image Transfer Activate',
      UpdateFirmware: 'Update Firmware',
      UploadFirmware: 'Upload Firmware',
      GetHardwareInfo: 'Get Hardware Info',
      ReadNicInfo: 'Read Nic Info',
      ReadNicSetup: 'Read Nic Setup',
      ReadRelay: 'Read Relay',
      ReadTimestamp: 'Read Timestamp',
      ReadNicData: 'Read Nic Data',
      NicSetup: 'Nic Setup',
      ReadLdrUpper: 'Read Ldr Upper',
      ReadLdrBottom: 'Read Ldr Bottom',
      ReadLdrMin: 'Read Ldr Min',
      SetLdrUpper: 'Set Ldr Upper',
      SetLdrBottom: 'Set Ldr Bottom',
      SetLdrMin: 'Set Ldr Min',
      ReadNicSerial: 'Read Nic Serial',
      ReadRelayWithLastSwitchOn: 'Read Relay With Last Switch On',
      ReadRelayWithLastSwitchOnAndOff: 'Read Relay With Last Switch On And Off',
      SetBlockSize: 'Set Block Size',
      MulticastGroupSetup: 'Multicast Group Setup',
      MulticastClassCSession: 'Multicast Class C Session',
      MulticastSetupConfirmation: 'Multicast Setup Confirmation',
      ImageTransferStatus: 'Image Transfer Status',
      GetFirmwareVersion: 'Get Firmware Version',
      ReadAlarmFakeOnOff: 'Read Alarm Fake OnOff',
      ConfigureApplicationGroup: 'Configure Application Group',
      ReadALarmLastGasp: 'Read Alarm Last Gasp',
      SetLastGaspVoltageLevel: 'Set Last Gasp Voltage Level',
      ReadAlarmVoltageMonitor: 'Read Alarm Voltage Monitor',
      SetVoltageMinimalInterval: 'Set Voltage Minimal Interval',
      SetAlarmFakeOnOffThreshold: 'Set Alarm Fake OnOff Threshold',
      ReadTemperatureValue: 'Read Temperature Value',
      ReadRelayWithDelay: 'Read Relay With Delay',
      DeviceCreated: 'Device Created',
      DeviceUpdated: 'Device Updated',
      ScheduleCreated: 'Schedule Created',
      ScheduleUpdated: 'Schedule Updated',
      GroupCreated: 'Group Created',
      GroupUpdated: 'Group Updated',
      SetAlarmFakeOnOff: 'Set Alarm Fake OnOff',
      ScheduleCanceled: 'Schedule Canceled',
      ScheduleDeleted: 'Schedule Deleted',
      DeviceDeleted: 'Device Deleted',
      GroupDeleted: 'Group Deleted',
      CheckScheduleStatus: 'Check Schedule Status',
      ActivateSchedule: 'Activate Schedule',
      DeactivateSchedule: 'Deactivate Schedule',
      CheckScheduleExist: 'Check Schedule Exist',
      ReadDeviceType: 'Read Device Type',
      WriteDeviceRole: 'Write Device Role',
      FullScheduleCommand: 'Full Schedule Command',
      ScheduleCreatedOnSystem: 'Schedule Created (System)',
      ActivateScheduleOnSystem: 'Activate Schedule (System)',
      CheckScheduleStatusOnSystem: 'Check Schedule Status (System)',
      WriteDeviceRoleOnSystem: 'Write Device Role (System)',
      DeactivateScheduleOnSystem: 'Deactivate Schedule (System)',
      CheckScheduleExistOnSystem: 'Check Schedule Exist (System)',
      ReadDeviceTypeOnSystem: 'Read Device Type (System)',
      SetDatetimeOnSystem: 'Set Datetime (System)',
      PeriodicConfiguration: 'Periodic Configuration',
      Decommissioning: 'Decommissioning',
      OpenSession: 'Open Session',
      ReadMeterSerial: 'Read Meter Serial',
      ImportMassMeters: 'Import Mass Meters',
      SaveConfig: 'Save Config',
      ReadConfig: 'Read Config',
      SaveTime: 'Save Time',
      TimeCorrection: 'Time Correction',
      Storage: 'Storage',
      FuotaPause: 'Fuota Pause',
      deleteSpecialDays: 'Delete Special Days',
      GetTotalizers: 'Get Totalizers',
      GetRelayStatusControl: 'Get Relay Status Control',
      SetRelayStatusControl: 'Set Relay Status Control',
      GetIntegrationInstantaneousReadings: 'Get Integration Instantaneous Readings',
      GetVoltageOutLongShort: 'Get Voltage Out Long and Short Alarm',
      RelayStatusOrca: 'Get Orca Relay Status',
      GetQeeOnDemand: 'Get QEE On Demand',
      GetQeeHistoricalData: 'Get QEE Historical Data',
      RecoverFragmentedPacket: 'Recover Fragmented Packet',
      DrpDrcEventLog: 'DRP and DRC Event Log',
      ReadTariffPeriods: 'Get Tariff Reading',
      SmartFuseAlarmAck: 'Alarm Ack',
      ImportAlarms: 'Import Alarms',
    },
    ServiceTypeEquatorial: {
      TurnOnPower: 'Reconnect',
      TurnOffPower: 'Cut',
      RequestRead: 'Read Request',
      RequestNoteLq: 'QEE Request',
    },
    RequestStatusEquatorial: {
      Waiting: 'Waiting',
      Processing: 'Processing',
      Running: 'Running',
      CommunicationWithMDCFailed: 'Communication with MDC Failed',
      InternalFailure: 'Internal Failure',
      MDCTicketFinalized: 'MDC Ticket Finalized',
      MDCTicketFailed: 'MDC Ticket Failed',
      FinishedWithSuccess: 'Finished with Success',
      FinishedWithFailure: 'Finished with Failure',
      Cancelled: 'Cancelled',
    },
    CommandStatus: {
      CHANGING_COLLECTIVE_CUT_ALARM: 'Changing the Collective cut status',
      CHANGING_RELAY_STATUS: 'Changing Relay State',
      GBT: 'GBT',
      GET_QEE_INDICATORS: 'Requesting quality parameters',
      INSTANT_MEASURE: 'Requesting Instant Measure',
      MARK_ALARM_AS_READ: 'Marking Alarm As Read',
      NIC_RESET: 'NIC Reset',
      RECOVER_EVENT_QEE_INDICATOR: 'Retrieving Quality Parameters',
      RECOVER_FROZEN_DATA: 'Recovering Energy Totalizers',
      RECOVER_MASS_MEMORY: 'Recovering Mass Memory',
      REGISTERING_DATETIME: 'Recording Date and Time',
      REGISTERING_KEYS: 'Registering Keys',
      RELAY_ON_ALL_METERS_SMC: 'Reconnecting all clients',
      REQUESTING_DATE: 'Requesting Date',
      REQUESTING_RELAY_STATUS: 'Requesting Relay Status',
      REQUESTING_RELAY_STATUS_ALL_SMC: 'Requesting Relay Status',
      REQUESTING_SERIAL: 'Requesting Serial',
      REQUEST_DOOR_STATUS: 'Getting Status of the Collective Cut',
      ROLLBACK: 'Running RollBack!',
      SET_CURRENT: 'Changing Cutting Current',
      SET_INTERVAL_OF_LONG_OUT_VOLTAGE: 'Setting Long Out Capture Interval',
      SET_INTERVAL_OF_QEE: 'Setting DRP/DRC Capture Interval',
      SET_STANDARD_FROZEN_DATA: 'Configuring Default Energy Template',
      UPLINK_PERIOD: 'Changing the read uplink period',
      WAITING_COMMAND: 'Awaiting Command',
    },
    ComunicationStatus: {
      BUSY: 'Busy',
      COMMUNICATION_FAILED: 'Communication Failure',
      NO_INFORMATION: 'No information',
      SUCCESS: 'Success',
    },
    tariffsType: {
      tariff: 'Rate Type',
      IRRIGANTE: 'Irrigante',
      TARIFA_BRANCA: 'White Tariff',
      GD: 'Distributed Generation',
      IRRIGANTE_GD: 'Irrigante Distributed Generation',
      TARIFA_BRANCA_GD: 'White Tariff Distributed Generation',
      CONVENCIONAL: 'Conventional',
      CONVENCIONAL_GD: 'Conventional Distributed Generation',
      MMGD: 'MMGD',
      REN871: 'REN871',
      GRUPO_B_IRRIGANTE: 'Group B Irrigante',
      GRUPO_A: 'Group A',
      CLIENTE_LIVRE: 'Free Customer',
      TARIFA_BRANCA_MMGD: 'White Tariff + MMGD',
      TARIFA_BRANCA_MMGD_IRRIGANTE: 'White Tariff + MMGD + Irrigante',
      GRUPO_A_IRRIGANTE: 'Group A Irrigante',
    },
    MeterTypes: {
      Integration: 'Integration',
      IntegrationDcu: 'Integration Wasion DCU',
      Nepen: 'Integration MDX',
    },
    CceeIntegrationMethod: {
      placeholder: 'Select CCEE integration method',
      None: 'None',
      Soap: 'SOAP',
      Rest: 'REST',
    },
    AlarmDescription: {
      POWER_RESTORE: 'Power Restore',
      TERMINAL_COVER_REMOVED_START: 'Terminal cover removed start',
      TERMINAL_COVER_REMOVED_END: 'Terminal cover removed end',
      CURRENT_REVERSAL_L1_START: 'Current reversal L1 start',
      CURRENT_REVERSAL_L1_END: 'Current reversal L1 end',
      MAGNETIC_FIELD_DETECTION_START: 'Magnetic field detection start',
      MAGNETIC_FIELD_DETECTION_END: 'Magnetic field detection end',
      METER_COVER_OPEN: 'Meter cover open',
      METER_COVER_CLOSE: 'Meter cover close',
      METER_AUTHENTICATION_FAILS: 'Meter authentication fails',
      PRESENCE_OF_VOLTAGE_AT_LOAD_SIDE_START: 'Presence of voltage at Load side start',
      PRESENCE_OF_VOLTAGE_AT_LOAD_SIDE_END: 'Presence of voltage at Load side end',
      FIRMWARE_UPGRADE: 'Firmware upgrade',
      DISCONNECT: 'Disconnect',
      CONNECT: 'Connect',
      CURRENT_REVERSAL_L2_START: 'Current reversal L2 start',
      CURRENT_REVERSAL_L2_END: 'Current reversal L2 end',
      CURRENT_REVERSAL_L3_START: 'Current reversal L3 start',
      CURRENT_REVERSAL_L3_END: 'Current reversal L3 end',
      MISSING_VOLTAGE_L1_START: 'Missing voltage L1 start',
      MISSING_VOLTAGE_L1_END: 'Missing voltage L1 end',
      MISSING_VOLTAGE_L2_START: 'Missing voltage L2 start',
      MISSING_VOLTAGE_L2_END: 'Missing voltage L2 end',
      MISSING_VOLTAGE_L3_START: 'Missing voltage L3 start',
      MISSING_VOLTAGE_L3_END: 'Missing voltage L3 end',
      UNDER_VOLTAGE_L1_START: 'Under voltage L1 start',
      UNDER_VOLTAGE_L1_END: 'Under voltage L1 end',
      UNDER_VOLTAGE_L2_START: 'Under voltage L2 start',
      UNDER_VOLTAGE_L2_END: 'Under voltage L2 end',
      UNDER_VOLTAGE_L3_START: 'Under voltage L3 start',
      UNDER_VOLTAGE_L3_END: 'Under voltage L3 end',
      OVER_VOLTAGE_L1_START: 'Over voltage L1 start',
      OVER_VOLTAGE_L1_END: 'Over voltage L1 end',
      OVER_VOLTAGE_L2_START: 'Over voltage L2 start',
      OVER_VOLTAGE_L2_END: 'Over voltage L2 end',
      OVER_VOLTAGE_L3_START: 'Over voltage L3 start',
      OVER_VOLTAGE_L3_END: 'Over voltage L3 end',
    },
  },
  NetworkManagement: {
    tables: {
      signalQualityTitle: 'Signal Quality History',
      commandsPacketsTitle: 'Command Packets History',
      status: 'Command Status',
      commandType: 'Command Type',
      lastUpdate: 'Last Update',
      serial: 'Serial',
      commandsPackagesHistory: 'Command Packages History',
      executeNetworkCommands: 'Execute Network Commands',
    },
    map: {
      tooltip: 'Signal Legend',
      noSignal: 'No Signal',
      poorSignal: 'Very Poor',
      fairSignal: 'Weak',
      regularSignal: 'Regular',
      goodSignal: 'Good',
      excellentSignal: 'Excellent',
    },
    errors: {
      fetchCommandsPackagesHistoryError: 'Error fetching command packages history',
      fetchSignalQualityHistoryError: 'Error fetching signal quality history',
      fetchMetersError: 'Error fetching meters',
    },
    general: {
      NoSentPackages: 'No Packages Sent for this Command',
      NoReceivedPackages: 'No Packages Received for this Command',
      NetworkDetails: 'Meter Network Details',
      DailySignalQualityHistory: 'Signal Quality',
      SignalQualityHistory: 'Signal History',
      RssiQualityHistory: 'RSSI History',
      commandsPackagesHistory: 'Network Commands History',
    },
  },
  ReadingsTable: {
    serial: 'Serial',
    dateTime: 'Date and Time',
    amrProfileStatus: 'AMR Profile Status',
    totalEnergy_Wh: 'Total Energy (kWh)',
    totalActiveEnergy_Wh: 'Total Active Energy (kWh)',
    totalDirectActiveEnergy_Wh: 'Total Direct Active Energy (kWh)',
    borderTotalizer_Wh: 'Peak Totalizer (kWh)',
    reservedTotalizer_Wh: 'Reserved Totalizer (kWh)',
    offBorderTotalizer_Wh: 'Off-Peak Totalizer (kWh)',
    apparentPowerA: 'Apparent Power A',
    apparentPowerB: 'Apparent Power B',
    apparentPowerC: 'Apparent Power C',
    reactivePowerA: 'Reactive Power A',
    reactivePowerB: 'Reactive Power B',
    reactivePowerC: 'Reactive Power C',
    totalIntermediary_Wh: 'Intermediate Total (kWh)',
    generatedEnergyTotal_Wh: 'Total Generated Energy (kWh)',
    totalReverseActiveEnergy_Wh: 'Total Reverse Active Energy (kWh)',
    generatedOffBorderEnergyTotal_Wh: 'Generated Off-Peak Energy (kWh)',
    generatedIntermediaryEnergyTotal_Wh: 'Generated Intermediate Energy (kWh)',
    generatedBorderEnergyTotal_Wh: 'Generated Peak Energy (kWh)',
    generatedReservedEnergyTotal_Wh: 'Generated Reserved Energy (kWh)',
    q1ReactiveEnergy_VarH: 'Q1 Reactive Energy (kVArh)',
    q2ReactiveEnergy_VarH: 'Q2 Reactive Energy (kVArh)',
    q3ReactiveEnergy_VarH: 'Q3 Reactive Energy (kVArh)',
    q4ReactiveEnergy_VarH: 'Q4 Reactive Energy (kVArh)',
    reactiveEnergyImportQiRi_VarH: 'Reactive Energy Import QI (+Ri) (kVArh)',
    reactiveEnergyImportQivRc_VarH: 'Reactive Energy Import QIV (-Rc) (kVArh)',
    phaseAVoltageAverage_V: 'Phase A Average Voltage (V)',
    phaseBVoltageAverage_V: 'Phase B Average Voltage (V)',
    phaseCVoltageAverage_V: 'Phase C Average Voltage (V)',
    lastAverageVoltageL1_V: 'L1 Average Voltage (V)',
    lastAverageVoltageL2_V: 'L2 Average Voltage (V)',
    lastAverageVoltageL3_V: 'L3 Average Voltage (V)',
    phaseACurrentAverage_A: 'Phase A Average Current (A)',
    phaseBCurrentAverage_A: 'Phase B Average Current (A)',
    phaseCCurrentAverage_A: 'Phase C Average Current (A)',
    lastAverageCurrentL1_A: 'L1 Average Current (A)',
    lastAverageCurrentL2_A: 'L2 Average Current (A)',
    lastAverageCurrentL3_A: 'L3 Average Current (A)',
    totalPowerFactor_NoUnit: 'Total Power Factor',
    phaseAVoltageThd_NoUnit: 'Phase A Voltage THD',
    phaseBVoltageThd_NoUnit: 'Phase B Voltage THD',
    phaseCVoltageThd_NoUnit: 'Phase C Voltage THD',
    phaseACurrentThd_NoUnit: 'Phase A Current THD',
    phaseBCurrentThd_NoUnit: 'Phase B Current THD',
    phaseCCurrentThd_NoUnit: 'Phase C Current THD',
    activePowerThd_NoUnit: 'Active Power THD',
    group0DirectEnergy_Wh: 'Group 0 Direct Energy (kWh)',
    group0InductiveReactiveDirectEnergy_VArhPlus: 'Group 0 Direct Energy (kVArh+)',
    group0CapacitiveReactiveDirectEnergy_VArhMinus: 'Group 0 Direct Energy (kVArh–)',
    group1ReverseEnergy_Wh: 'Group 1 Reverse Energy (kWh)',
    group1InductiveReactiveReverseEnergy_VArhPlus: 'Group 1 Reverse Energy (kVArh+)',
    group1CapacitiveReactiveReverseEnergy_VArhMinus: 'Group 1 Reverse Energy (kVArh–)',
    group2VoltageVaH_V: 'Group 2 Voltage Va (V)',
    group2VoltageVbH_V: 'Group 2 Voltage Vb (V)',
    group2VoltageVcH_V: 'Group 2 Voltage Vc (V)',
    group3CurrentIaH_A: 'Group 3 Current Ia (A)',
    group3CurrentIbH_A: 'Group 3 Current Ib (A)',
    group3CurrentIcH_A: 'Group 3 Current Ic (A)',
    group4ThdVoltageVaH_NoUnit: 'Group 4 THD Voltage Va',
    group4ThdVoltageVbH_NoUnit: 'Group 4 THD Voltage Vb',
    group4AngleUiA_deg: 'Group 4 Angle Ui A (º)',
    group4AngleUiB_deg: 'Group 4 Angle Ui B (º)',
    group4AngleUiC_deg: 'Group 4 Angle Ui C (º)',
    group4ThdVoltageVcH_NoUnit: 'Group 4 THD Voltage Vc',
    group5ThdCurrentIaH_NoUnit: 'Group 5 THD Current Ia',
    group5ThdCurrentIbH_NoUnit: 'Group 5 THD Current Ib',
    group5ThdCurrentIcH_NoUnit: 'Group 5 THD Current Ic',
    totalEnergyIncremental_Wh: 'Total Energy Incremental (kWh)',
    q1ReactiveEnergyIncremental_VarH: 'Q1 Reactive Energy Incremental (kVArh)',
    q4ReactiveEnergyIncremental_VarH: 'Q4 Reactive Energy Incremental (kVArh)',
    voltageA: 'Voltage A (V)',
    voltageB: 'Voltage B (V)',
    voltageC: 'Voltage C (V)',
    currentA: 'Current A (A)',
    currentB: 'Current B (A)',
    currentC: 'Current C (A)',
    activePowerA: 'Active Power A (W)',
    activePowerB: 'Active Power B (W)',
    activePowerC: 'Active Power C (W)',
    maximumVoltageA_V: 'Maximum Voltage A (V)',
    maximumVoltageB_V: 'Maximum Voltage B (V)',
    maximumVoltageC_V: 'Maximum Voltage C (V)',
    minimumVoltageA_V: 'Minimum Voltage A (V)',
    minimumVoltageB_V: 'Minimum Voltage B (V)',
    minimumVoltageC_V: 'Minimum Voltage C (V)',
    maximumCurrentA_A: 'Maximum Current A (A)',
    minimumVoltageL1_V: 'Minimum Voltage L1 (V)',
    minimumVoltageL2_V: 'Minimum Voltage L2 (V)',
    minimumVoltageL3_V: 'Minimum Voltage L3 (V)',
    totalInductiveReactiveEnergy_VarH: 'Total Inductive Reactive Energy (kVArh)',
    totalCapacitiveReactiveEnergy_VarH: 'Total Capacitive Reactive Energy (kVArh)',
    reactiveEnergyImportQiiiRi_VarH: 'Reactive Energy Import QIII (–Ri) (kVArh)',
    reactiveEnergyImportQiiRc_VarH: 'Reactive Energy Import QII (+Rc) (kVArh)',
    maximumVoltageL1_V: 'Maximum Voltage L1 (V)',
    maximumVoltageL2_V: 'Maximum Voltage L2 (V)',
    maximumVoltageL3_V: 'Maximum Voltage L3 (V)',
    maximumCurrentL1_A: 'Maximum Current L1 (A)',
    maximumCurrentL2_A: 'Maximum Current L2 (A)',
    maximumCurrentL3_A: 'Maximum Current L3 (A)',
    instantaneousVoltageL1_V: 'Instantaneous Voltage L1 (V)',
    instantaneousVoltageL2_V: 'Instantaneous Voltage L2 (V)',
    instantaneousVoltageL3_V: 'Instantaneous Voltage L3 (V)',
    instantaneousCurrentL1_V: 'Instantaneous Current L1 (A)',
    instantaneousCurrentL2_V: 'Instantaneous Current L2 (A)',
    instantaneousCurrentL3_V: 'Instantaneous Current L3 (A)',
    instantaneousActiveImportPowerAPlusL1: 'Instantaneous Active Import Power L1 (W)',
    instantaneousActiveExportPowerAMinusL1: 'Instantaneous Active Export Power L1 (W)',
    instantaneousReactiveImportPowerRPlusL1: 'Instantaneous Reactive Import Power L1 (VAr)',
    instantaneousReactiveExportPowerRMinusL1: 'Instantaneous Reactive Export Power L1 (VAr)',
    totalPowerFactorPhaseA_NoUnit: 'Phase A Power Factor',
    totalPowerFactorPhaseB_NoUnit: 'Phase B Power Factor',
    totalPowerFactorPhaseC_NoUnit: 'Phase C Power Factor',
    inductiveDirectIncremental_VarH: 'Direct Inductive Incremental (kVArh)',
    capacitiveDirectIncremental_VarH: 'Direct Capacitive Incremental (kVArh)',
    inductiveReverseIncremental_VarH: 'Reverse Inductive Incremental (kVArh)',
    capacitiveReverseIncremental_VarH: 'Reverse Capacitive Incremental (kVArh)',
    directActiveEnergyIncremental_Wh: 'Direct Active Energy Incremental (kWh)',
    reverseActiveEnergyIncremental_Wh: 'Reverse Active Energy Incremental (kWh)',
  },
  FrozenData: {
    serial: 'Serial',
    dateTime: 'Reading Time',
    amrProfileStatus: 'AMR Profile Status',
    borderTotalizer_Wh: 'Peak Active Energy (kWh)',
    totalEnergy: 'Total Active Energy (kWh)',
    totalEnergy_Wh: 'Total Active Energy (kWh)',
    forderTotalizer_Wh: 'Direct Active Energy T1 (kWh)',
    reservedTotalizer_Wh: 'Reserved Active Energy (kWh)',
    offBorderTotalizer_Wh: 'Off-Peak Active Energy (kWh)',
    totalIntermediary_Wh: 'Intermediate Active Energy (kWh)',
    generatedEnergyTotal_Wh: 'Generated Active Energy (kWh)',
    totalReverseActiveEnergy_Wh: 'Total Reverse Active Energy (kWh)',
    generatedOffBorderEnergyTotal_Wh: 'Generated Off-Peak Energy (kWh)',
    generatedIntermediaryEnergyTotal_Wh: 'Generated Intermediate Energy (kWh)',
    generatedBorderEnergyTotal_Wh: 'Generated Peak Energy (kWh)',
    generatedReservedEnergyTotal_Wh: 'Generated Reserved Energy (kWh)',
    positiveReactiveEnergy_Wh: 'Positive Reactive Energy (kWh)',
    negativeReactiveEnergy_Wh: 'Negative Reactive Energy (kWh)',
    totalDirectEnergyTariffC_Wh: 'Direct Active Energy Tariff C',
    totalDirectEnergyTariffB_Wh: 'Direct Active Energy Tariff B',
    totalDirectEnergyTariffA_Wh: 'Direct Active Energy Tariff A',
    totalDirectEnergyTariffD_Wh: 'Direct Active Energy Tariff D',
    totalReverseEnergyTariffC_Wh: 'Reverse Active Energy Tariff C',
    totalReverseEnergyTariffB_Wh: 'Reverse Active Energy Tariff B',
    totalReverseEnergyTariffA_Wh: 'Reverse Active Energy Tariff A',
    totalReverseEnergyTariffD_Wh: 'Reverse Active Energy Tariff D',
    totalInductiveReactiveEnergy_VarH: 'Total Inductive Reactive Energy (kVarH)',
    totalCapacitiveReactiveEnergy_VarH: 'Total Capacitive Reactive Energy (kVarH)',
    totalInductiveReactiveEnergyTariffC_Wh: 'Reverse Active Energy Tariff C',
    totalInductiveReactiveEnergyTariffB_Wh: 'Reverse Active Energy Tariff B',
    totalInductiveReactiveEnergyTariffA_Wh: 'Reverse Active Energy Tariff A',
    totalInductiveReactiveEnergyTariffD_Wh: 'Reverse Active Energy Tariff D',
    generatedEnergyTotal: 'Generated Active Energy (kWh)',
    generatedOffBorderEnergyTotal: 'Generated Off-Peak Energy',
    generatedIntermediaryEnergyTotal: 'Generated Intermediate Energy',
    generatedBorderEnergyTotal: 'Generated Peak Energy',
    borderTotalizer: 'Peak Totalizer',
    reservedTotalizer: 'Reserved Totalizer',
    offBorderTotalizer: 'Off-Peak Totalizer',
    totalIntermediary: 'Intermediate Total',
    totalReactiveInductiveEnergy: 'Total Inductive Reactive Energy',
    totalReactiveCapacitiveEnergy: 'Total Capacitive Reactive Energy',
    consumedMaximunDemand_W: 'Maximum Consumed Demand (kW)',
    injectedMaximunDemand_W: 'Maximum Injected Demand (kW)',
    reverseCapacitiveReactiveEnergy_VarH: 'Reverse Capacitive Reactive Energy (kVarH)',
    reverseInductiveReactiveEnergy_VarH: 'Reverse Inductive Reactive Energy (kVarH)',
  },
  app: {
    name: 'Electricity Monitoring System',
    description: 'Control panel for measurement, control and energy reports',
    language: 'Select the language',
  },
  navigation: {
    home: 'Home',
    dashboard: 'Dashboard',
    devices: 'Manage Devices',
    reports: 'Detailed Reports',
    settings: 'System Settings',
    logout: 'Logout',
    meters: 'Meters',
    scheduledCommands: {
      label: 'Scheduled Commands',
      systemCommands: 'System Commands',
      routineListing: 'Routine Listing',
    },
    massCommands: {
      label: 'Mass Commands',
      readings: 'Readings',
      cutReconnect: 'Cut/Reconnect',
    },
    customReport: 'Reports',
    ccee: 'Free Market',
    energyBalance: 'Energy Balance',
    smcs: 'SMCs',
    billing: 'Billing',
    dataExtraction: 'Data extraction',
    downloadCenter: 'Download Center',
    transformers: 'Transformers',
    areas: 'Areas',
    regions: 'Regions',
    serviceNotes: 'Service Notes',
    vee: {
      label: 'VEE',
      overview: 'VEE Overview',
      groupsLegacy: 'VEE Groups (legacy)',
      monitoring: 'Monitoring',
      resume: 'Summary',
      batchApproval: 'Batch Approval',
      readingImport: 'Reading Import',
      requestQueue: 'Request Queue',
      zeroConsumption: 'Zero Consumption',
      limitDeviations: 'Limit Deviations',
      executionMonitor: 'Execution Monitor',
      configuration: {
        label: 'VEE Configuration',
        groups: 'VEE Groups',
        rules: 'Rule Library',
        thresholds: 'Rule Thresholds',
        calendar: 'Billing Calendar',
        notifications: 'Notifications',
        hierarchy: 'Hierarchy Association',
        customRule: 'Custom Rule',
      },
    },
    iagd: {
      label: 'IAGD',
      overview: 'Overview',
      analysis: 'Analysis Status',
      settings: 'Settings',
      completeness: 'Data Completeness',
      ranking: 'Suspicion Ranking',
    },
    management: {
      label: 'Management',
      firmware: 'Firmware',
      gateways: 'Gateways',
      users: 'Users',
      keys: 'Keys',
      tags: 'Tags',
      groups: 'Groups',
      clients: 'Clients',
      models: 'Models',
      configuration: 'Configuration',
    },
  },
  views: {
    iagd: {
      overviewTitle: 'Overview — IAGD',
      distributor: 'Distributor',
      analyzedUcs: 'GD UCs in analysis',
      analysis: {
        title: 'Analysis Status',
        funnelTitle: 'State Funnel',
        totalUcsGd: 'Total GD UCs',
        inAnalysis: 'In analysis',
        excluded: 'Excluded',
        ofTotal: 'of total',
        thresholdTitle: 'Completeness threshold',
        thresholdHint: 'UCs with completeness below this value are excluded from analysis.',
        configureThreshold: 'Configure in Settings',
        bandsTitle: 'Completeness bands',
        pipelineTitle: 'Processing',
        lastRun: 'Last analyzed cycle',
        nextRun: 'Next run',
        notScheduled: 'Not scheduled',
        stateDetail: {
          titleInAnalysis: 'UCs in analysis',
          titleExcluded: 'Excluded UCs',
        },
      },
      kpi: {
        totalUcsGd: 'Total GD UCs',
        riskHigh: 'High Risk',
        riskMedium: 'Medium Risk',
        totalFlags: 'Total Flags',
        metersInRanking: 'Meters in ranking',
        percentOfTotal: 'of total',
        accumulatedInPeriod: 'Accumulated in period',
      },
      charts: {
        riskDistribution: 'Risk Level Distribution',
        flagComposition: 'Flag Composition by Type',
        scoreDistribution: 'Normalized Score — Distribution',
        topMeters: 'Top 10 Meters by Score',
      },
      flagTypes: {
        quedaBrusca: 'Abrupt Drop',
        injForaDaJanela: 'Inj. Out of Window',
        consumoNoturno: 'Night Consumption',
        tensaoIrregular: 'Irregular Voltage',
      },
      riskLevels: {
        alto: 'High',
        medio: 'Medium',
        baixo: 'Low',
      },
      ranking: {
        title: 'Suspicion Ranking',
        ucsTag: 'UCs',
        riskLabel: 'Risk Level',
        allRisks: 'All',
        searchLabel: 'Search meter',
        searchPlaceholder: 'e.g. UC-000001',
        columns: {
          ucId: 'Meter',
          score: 'Score',
          riskLevel: 'Risk',
          quedaBrusca: 'Ab. Drop',
          injForaDaJanela: 'Out of Win.',
          consumoNoturno: 'Night Cons.',
          tensaoIrregular: 'Voltage',
          cycle: 'Cycle',
        },
      },
      rankingModal: {
        titleRisk: 'Risk Level — Meters',
        titleFlag: 'Flag Type — Meters',
        titleScore: 'Score Range — Meters',
        filterLabelFlag: 'Flag Type',
        filterLabelScore: 'Score Range',
      },
      completeness: {
        title: 'Data Completeness',
        datePlaceholder: 'Month/Year',
        dateLabel: 'Period',
        searchLabel: 'Search by UC ID',
        searchPlaceholder: 'e.g. UC-000001',
        exportCsv: 'Export CSV',
        metersTag: 'meters',
        excludedTag: 'excluded from analysis',
        legendTitle: 'Legend',
        columns: {
          ucId: 'UC ID',
          completeness: 'Completeness',
          excludedReadings: 'Missing Readings',
          status: 'Status',
        },
        status: {
          included: 'Included',
          attention: 'Attention',
          excluded: 'Excluded',
        },
        cluster: {
          high: 'High',
          medium: 'Medium',
          low: 'Low',
        },
        filterStatus: 'Status',
        filterCluster: 'Completeness Bracket',
        filterAll: 'All',
      },
      ucDetail: {
        period: 'Period',
        periodTo: 'to',
        chartTitle: 'HISTORY',
        readings: 'READINGS (15 MIN)',
        flaggedRegionsLegend: 'Red-shaded regions indicate days with active flags.',
        anomalyIndicators: 'ANOMALY INDICATORS',
        flagHistory: 'ACTIVE FLAGS HISTORY',
        tabs: {
          energy: 'Energy (kWh)',
          voltage: 'Voltage (V)',
          current: 'Current (A)',
        },
        series: {
          clusterRef: 'Cluster ref.',
          energyDirect: 'Direct Energy',
          energyReverse: 'Reverse Energy',
          movingAverage: 'Moving Average',
          voltage: 'Voltage',
          current: 'Current',
        },
        noData: 'No IAGD analysis available for this consumer unit.',
      },
      settings: {
        title: 'Settings',
        save: 'Save settings',
        saving: 'Saving...',
        saveSuccess: 'Settings saved successfully',
        saveError: 'Error saving settings',
        solarWindow: {
          title: 'Solar Window',
          start: 'Start',
          end: 'End',
          startPlaceholder: 'e.g. 06:00',
          endPlaceholder: 'e.g. 20:00',
        },
        flagThresholds: {
          title: 'Flag Thresholds',
          abruptDrop: 'Abrupt Drop (%)',
          abruptDropHint: 'Drop relative to moving average (default: 40%)',
          nightConsumption: 'Night Consumption Z-score',
          nightConsumptionHint: 'Statistical deviation threshold (default: 2.5)',
          irregularVoltage: 'Irregular Voltage Z-score',
          irregularVoltageHint: 'Daily σ deviation threshold (default: 2.5)',
        },
        pipelineParams: {
          title: 'Pipeline Parameters',
          completeness: 'Completeness Threshold (%)',
          completenessHint: 'Meters below this value are excluded (default: 70%)',
          clusters: 'Number of Clusters (K)',
          clustersHint: 'Used in consumption profile K-Means',
          analysisWindow: 'Analysis window (days)',
        },
        schedules: {
          title: 'Schedules',
          scoring: 'Cron — Scoring',
          scoringHint: 'Cron format. Default: 0 2 * * * (daily, 02h UTC)',
          clustering: 'Cron — Clustering',
          clusteringHint: 'Default: 0 3 * * 1 (weekly, Mon. 03h UTC)',
        },
      },
    },
    downloads: {
      exportStarted: 'Export started',
      exportStartedDefault:
        'The file will be available in the downloads tab as soon as the process is finished.',
      exportCompleted: 'File available',
      exportCompletedDetail: 'The file is now available in the Download Center.',
      exportError: 'Export error',
      exportErrorDefault: 'The export could not be completed',
      exportDelayed: 'Export still processing',
      exportDelayedDetail:
        'The export is taking longer than expected. You can track its progress in the Download Center.',
    },
    massCommands: {
      invalidModel: 'Invalid model',
      requiredSerialColumn: 'The required column is: Serial',
      invalidDateColumnFormat:
        'The Date column must be in the format: year-month-day, for example 2026-01-01.',
      billingProcessStarted:
        'Billing process started. You will be redirected to track its progress.',
      billingProcessStartError: 'Could not start the billing process.',
    },
    dashboard: {
      title: 'Dashboard',
      tabs: {
        general: 'General',
        commands: 'Commands',
        alarms: 'Alarms',
        averageVariation: 'Average Variation',
        abruptVariation: 'Abrupt Variation',
        effectivenessAndAvailability: 'Effectiveness and Availability',
        quality: 'Quality',
        vee: 'VEE',
      },
      effectivenessDailyReport: {
        title: 'Daily report',
        description:
          'This download generates the previous day report and does not use the filters below.',
        action: 'Download report',
      },
      averageVariation: {
        titleConfigAverageVariation: 'Abrupt Variation Configuration',
        dailyConsumption: 'Daily Consumption',
        weeklyConsumption: 'Weekly Consumption',
        monthlyConsumption: 'Monthly Consumption',
        events: 'Events',
        alarms: 'Alarms',
        dailySettings: 'Daily Variation Settings',
        weeklySettings: 'Weekly Variation Settings',
        monthlySettings: 'Monthly Variation Settings',
        weekDay: 'Week Day',
        month: 'Month',
        weekDays: {
          all: 'All',
          monday: 'Monday',
          tuesday: 'Tuesday',
          wednesday: 'Wednesday',
          thursday: 'Thursday',
          friday: 'Friday',
          saturday: 'Saturday',
          sunday: 'Sunday',
        },
        months: {
          all: 'All',
          january: 'January',
          february: 'February',
          march: 'March',
          april: 'April',
          may: 'May',
          june: 'June',
          july: 'July',
          august: 'August',
          september: 'September',
          october: 'October',
          november: 'November',
          december: 'December',
        },
        placeholders: {
          selectWeekDay: 'Select a day of the week',
          selectMonth: 'Select a month',
          selectEventType: 'Select event type',
          loading: 'Loading...',
        },
        eventType: 'Event Type',
        eventTypes: {
          all: 'All',
          flow_inversion: 'Flow Inversion',
          incomplete_memory: 'Incomplete Energy',
          abrupt_consumption_variation_day: 'Abrupt Consumption Variation (Previous Day)',
          abrupt_consumption_variation_week: 'Abrupt Consumption Variation (Previous Week)',
          abrupt_consumption_variation_month: 'Abrupt Consumption Variation (Previous Month)',
          abrupt_generation_variation_day: 'Abrupt Generation Variation (Previous Day)',
          abrupt_generation_variation_week: 'Abrupt Generation Variation (Previous Week)',
          abrupt_generation_variation_month: 'Abrupt Generation Variation (Previous Month)',
          last_gasp: 'Last Gasp',
        },
        abruptVariation: 'Abrupt Variation',
        abruptVariationChart: 'Abrupt Variation Chart',
        settings: {
          title: 'Abrupt Variation Settings',
          percentageValue: 'Reference Value (%)',
          interval: 'Interval',
          loading: 'Loading...',
          cancel: 'Cancel',
          save: 'Save',
        },
        search: 'Search',
        tableHeaders: {
          startWeek: 'Start Week',
          endWeek: 'End Week',
          date: 'Date',
          weekDay: 'Week Day',
          month: 'Month',
          serial: 'Serial',
          instalation: 'Instalation',
          installation: 'Installation',
          consumption: 'Consumption (kWh)',
          generation: 'Generation (kWh)',
          difference: 'Balance (kWh)',
          startMonth: 'Start Month',
          endMonth: 'End Month',
          eventDateTime: 'Event Date/Time',
          eventType: 'Event Type',
        },
      },
    },
    veeDashboard: {
      overviewTitle: 'VEE Overview',
      filters: {
        title: 'Filters',
        region: 'Region',
        tariffClass: 'Tariff Class',
        technology: 'Technology',
        period: 'Period',
        group: 'VEE Group',
        selectRegion: 'Select the region',
        selectTariffClass: 'Select the tariff class',
        selectTechnology: 'Select the technology',
        selectPeriod: 'Select the period',
        selectGroup: 'Select the VEE group',
        apply: 'Apply',
        clear: 'Clear',
      },
      cards: {
        validatedReadings: 'Validated Readings',
        validatedReadingsCaption: 'of total readings in the period',
        pendingExceptions: 'Pending Exceptions',
        estimatesToApprove: 'Estimates to Approve',
        dataGaps: 'Data Gaps',
        communicationFailures: 'Communication Failures',
        nextBilling: 'Next Billing',
        aging: 'aging',
        days: 'days',
        meters: 'meters',
        approveInBulk: 'Approve in bulk',
        approveInBulkDialog: {
          title: 'Approve estimates in bulk',
          message: 'Confirm bulk approval of {count} pending estimate(s)?',
          cancel: 'Cancel',
          confirm: 'Approve',
          successSummary: 'Estimates approved in bulk successfully.',
        },
      },
      trendChart: {
        title: 'Data Quality Trend',
        validated: 'Validated',
        exception: 'Exception',
        granularity: 'Granularity',
        daily: 'Daily',
        weekly: 'Weekly',
        monthly: 'Monthly',
      },
      communicationStatus: {
        title: 'Communication Status',
        online: 'Online',
        offline: 'Offline',
        absent: 'Absent',
      },
      alerts: {
        title: 'Recent Alerts',
        alert: 'Alert',
        severity: 'Severity',
        meter: 'Meter',
        date: 'Date',
        viewDetails: 'View details',
        empty: 'No recent alerts',
        detailsDialog: {
          title: 'Alert Details',
          close: 'Close',
          resolve: 'Mark as resolved',
          resolveSuccess: 'Alert marked as resolved successfully.',
        },
      },
      groupsTable: {
        title: 'Groups',
        group: 'Group',
        validatedPercent: '% Validated',
        exceptions: 'Exceptions',
        pendingEstimates: 'Pending Estimates',
        nextBilling: 'Next Billing',
        empty: 'No groups found',
        downloadSuccess: 'Download started successfully.',
      },
      serviceRequests: {
        title: 'Service Requests',
        meter: 'Meter',
        issue: 'Issue',
        slaRemaining: 'SLA Remaining',
        status: 'Status/Action',
        empty: 'No pending requests',
        detailsDialog: {
          title: 'Request Details',
          close: 'Close',
          resolve: 'Mark as resolved',
          resolveSuccess: 'Request marked as resolved successfully.',
        },
      },
      refreshSuccess: 'Data updated successfully.',
    },
    customReport: {
      title: 'Reports',
      emptyState: 'No data to display.',
      readings: 'Readings',
      itemsFound: 'items found',
      comingSoon: 'Coming soon.',
      transformers: 'Transformers',
      warnings: {
        invalidPeriodSummary: 'Invalid period',
        invalidPeriodDetail:
          'On the Abrupt Variation tab, the selected period must contain dates from the same year. Select dates within the same calendar year.',
      },
      events: {
        charts: {
          overload: 'Transformers in Overload',
          overvoltage: 'Transformers in Overvoltage',
          undervoltage: 'Transformers in Undervoltage',
          unbalance: 'Voltage Unbalance',
        },
        tables: {
          overload: 'Overload',
          overvoltage: 'Overvoltage',
          undervoltage: 'Undervoltage',
          unbalance: 'Voltage Unbalance',
        },
        columns: {
          overload: 'Overload (%)',
          overvoltage: 'Overvoltage (%)',
          undervoltage: 'Undervoltage (%)',
          unbalance: 'Unbalance (%)',
        },
        viewMore: 'See More',
      },
      tabs: {
        general: 'Overview',
        events: 'Events',
        alarms: 'Alarms',
        loads: 'Loads',
        abruptVariation: 'Abrupt Variation',
      },
      ccee: {
        dateRange: 'Select period',
        kpi: {
          metersOnline: 'Online Meters',
          readingsSent: 'Readings Sent (Today)',
          successRate: 'Free Market Success Rate',
          pendingTickets: 'Pending Tickets',
        },
        statusMap: {
          title: 'Status Map',
          accepted: 'Data Accepted',
          waiting: 'Awaiting CCEE Confirmation',
          lacuna: 'Gap',
          failed: 'Submission Failed',
        },
        alerts: {
          title: 'Highlighted Alerts',
          columns: {
            meter: 'Meter',
            alert: 'Alert',
            priority: 'Priority',
          },
          priority: {
            low: 'Low',
            medium: 'Medium',
            high: 'High',
          },
          filters: {
            serial: 'Meter Serial',
            priority: 'Priority',
            allPriorities: 'All priorities',
          },
          meterModal: {
            title: 'Related Meters',
          },
        },
        sendStatus: {
          title: 'Send Status',
          columns: {
            meter: 'Meter',
            datetime: 'Date/Time',
            status: 'Status',
            ticket: 'CCEE Ticket',
          },
          status: {
            accepted: 'Accepted',
            sent: 'Sent',
            rejected: 'Rejected',
            gap: 'Gap',
          },
          filters: {
            serial: 'Meter Serial',
            status: 'Status',
            allStatuses: 'All statuses',
          },
        },
        anomalies: {
          title: 'Detected Anomalies',
          columns: {
            meter: 'Meter',
            anomaly: 'Anomaly',
            suggestion: 'Suggestion',
            rule: 'Document rule',
            action: 'Action',
          },
        },
        performance: {
          title: 'Performance over the last 30 days',
          metrics: {
            metersOnline: 'Online Meters',
            correctedGaps: 'Corrected Gaps',
            cceeAcceptance: 'CCEE Acceptance',
            sendRate: 'Send Rate',
          },
        },
        availableReports: {
          title: 'Available Reports',
          columns: {
            report: 'Report',
            type: 'Type',
          },
        },
        generatedFiles: {
          title: 'Generated Files',
          columns: {
            report: 'Report',
            period: 'Period',
            format: 'Format',
            items: 'Items',
            records: 'Records',
          },
        },
        collectionGrid: {
          title: 'Collection Extract',
          monthPicker: 'Select month',
          meter: 'Meter',
          noData: 'No data found for the selected period',
          filters: {
            serial: 'Filter by serial',
          },
        },
        readingsModal: {
          title: 'Readings',
          filters: {
            period: 'Period',
            status: 'Status',
            allStatuses: 'All statuses',
          },
          columns: {
            datetime: 'Date/Time',
            status: 'Status',
            ticket: 'CCEE Ticket',
            integrationMethod: 'Method',
            activeEnergyIn: 'Active Energy In',
            activeEnergyOut: 'Active Energy Out',
            reactiveEnergyIn: 'Reactive Energy In',
            reactiveEnergyOut: 'Reactive Energy Out',
            consumoKwh: 'Consumption',
          },
        },
      },
      filters: {
        equipment: 'Distributor',
        installation: 'MFINSTALA',
        region: 'Region',
        polygon: 'Polygon',
        load: 'Load',
        loadRange: '% LOAD',
        cluster: 'Cluster',
        selectPeriod: 'Select the period',
        minPlaceholder: 'Min',
        maxPlaceholder: 'Max',
        superintendency: 'Superintendency',
        sectional: 'Sectional',
        city: 'City',
        itemsSelected: 'items selected',
        equipmentOptions: {
          eqtlMa: 'EQTL-MA',
          eqtlBa: 'EQTL-BA',
          eqtlPi: 'EQTL-PI',
        },
        installationOptions: {
          mfinstala: 'MFINSTALA',
          finstala: 'FINSTALA',
          nfinstala: 'NFINSTALA',
        },
        regionOptions: {
          regional: 'Region',
          east: 'East',
          west: 'West',
        },
        polygonOptions: {
          default: 'Polygon',
          centerWest: 'Center-West',
          coast: 'Coast',
        },
        loadOptions: {
          default: 'Load',
          normal: 'Normal',
          overload: 'Overload',
        },
        clusterOptions: {
          default: 'Cluster',
          upTo100: 'Up to 100%',
          between100And125: '100% to 125%',
          above175: 'Above 175%',
        },
      },
      legend: {
        normalLoad: 'Normal Load',
        overload: 'Overload',
      },
      cards: {
        loadClusters: 'Load Clusters',
        overloadByPolygon: 'Overload by Polygon',
        maxMonthlyLoad: 'Maximum Monthly Load',
        maxLoad: 'Maximum Load',
        maxLoadCurve: 'Max Load Curve',
        maxPhaseUnbalanceCurve: 'Max Phase Unbalance Curve',
        timeByTier: 'Time by Tier',
        phaseUnbalanceClusters: 'Phase Unbalance Clusters',
      },
      charts: {
        maxLoadCurve: 'Max Load Curve',
        maxPhaseUnbalanceCurve: 'Max Phase Unbalance Curve',
        phaseUnbalanceClusters: 'Phase Unbalance',
      },
      tiers: {
        upTo100: 'up to 100%',
        between100And125: '100% to 125%',
        between125And150: '125% to 150%',
        between150And175: '150% to 175%',
        above175: 'Above 175%',
      },
      unbalance: {
        upTo10: 'up to 10%',
        between10And20: '10% to 20%',
        between20And30: '20% to 30%',
        between30And40: '30% to 40%',
        between40And50: '40% to 50%',
        above50: 'above 50%',
      },
      tables: {
        transformer: 'Transformer',
        transformerName: 'Transformer Name',
        loadPercent: '% Load',
        maxLoad: 'Max Load',
        cluster: 'Cluster',
        phaseUnbalance: 'Phase Unbalance',
        date: 'Date',
        month: 'Month',
        range: 'Range',
        total: 'Total',
        percent: 'Percent',
        polygon: 'Polygon',
        region: 'Region',
        normal: 'Normal',
        overload: 'Overload',
      },
      details: {
        mfinstala: 'MFINSTALA',
        distributor: 'Distributor',
        transformer: 'Transformer',
        power: 'Power',
        region: 'Region',
        polygon: 'Polygon',
        dataDate: 'Data Date',
        posto: 'Post',
        measurementDate: 'Measurement Date',
        imax: 'Imax',
        inum: 'Inum',
        loadPercent: '% Load',
        loadPercentA: '% Load A',
        loadPercentB: '% Load B',
        loadPercentC: '% Load C',
        clusterPercent: 'Cluster %',
        overload: 'Overload',
        phaseUnbalance: 'Phase Unbalance',
        unbalanceCluster: 'Unbalance Cluster',
        currentA: 'Current A',
        currentB: 'Current B',
        currentC: 'Current C',
        undefined: 'Undefined',
      },
    },
    process: {
      title: 'Process',
      user: 'Responsible User',
      processType: 'Process Type',
      updatedAt: 'Last Updated',
    },
    meters: {
      title: 'Meters',
      periodUpdateAt: 'Period of last update',
      meterInfo: {
        title: 'Meter Details',
        infoClient: 'Client Info',
        moreDetails: 'View More',
        noInformation: 'No information',
        serial: 'Serial',
        installation: 'Installation',
        displayConfigured: 'Display Configuration',
        firmware: 'Firmware',
        accountantStatus: 'Relay Status',
        referenceVoltage: 'Reference Voltage',
        status: 'Communication Status',
        associatedGateway: 'Associated gateway:',
        networkTypePublic: 'Public',
        networkTypePrivate: 'Private',
        latLong: 'Lat / Long',
        crcMassMemory: 'CRC Mass Memory',
        uplinkPeriod: 'Uplink Period',
        crcFrozenData: 'CRC Energy Totalizer',
        tags: 'Meter Tags',
        regional: 'Regional',
        sectional: 'Sectional',
        polygon: 'Polygon',
        potency: 'Potency',
        noTags: 'No tags found',
        meterModel: {
          manufacturer: 'Manufacturer',
        },
        delete: 'Delete',
        confirmDelete: 'Confirm deletion of meter',
        confirmDeleteDescription: 'Are you sure you want to delete the meter?',
        confirmDeleteText: 'Yes, delete',
        actions: {
          fileUpload: 'File upload',
          editReadings: 'Edit Readings',
          editTags: 'Configure Tags',
          searchTags: 'Search tags by name',
        },
        tabs: {
          overview: 'Overview',
          iagd: 'IA-GD',
          vee: 'VEE Visualization',
        },
      },
      criticalAlarms: {
        title: 'Critical Alerts',
        criticalAlarm: 'Critical alarm',
        readDateTime: 'Reading Time:',
        updatedAt: 'Last Update:',
        notFound: 'No critical alarms found!',
        relayFailure: 'Relay Failure',
        smiTimeout: 'SMI Timeout',
        lastGasp: 'Last Gasp',
        localReset: 'Local Reset',
        measurementError: 'Measurement System Error',
      },
      maps: {
        title: 'Map View',
        noLocation: 'No location available',
      },
      display: {
        title: 'Meter Display',
        config: 'Display Settings',
        save: 'Update Settings',
        readDisplay: 'Request Display Reading',
        '001': 'Current day, month, and year',
        '002': 'Current hour, minute, and seconds',
        '003': 'Total Active General',
        '004': 'Total Active Peak',
        '006': 'Total Active Reserved',
        '008': 'Total Active Off-Peak',
        '009': 'Total Active Intermediate',
        '024': 'Total Reactive Inductive Energy',
        '103': 'Total Reverse General',
        '104': 'Total Reverse Peak',
        '106': 'Total Reverse Reserved',
        '108': 'Total Reverse Off-Peak',
        '109': 'Total Reverse Intermediate',
      },
      placeholders: {
        serial: 'Enter meter serial',
      },
    },
    meterDetails: {
      titleWithSerial: 'Meter details - {serial}',
    },
    meterFileUpload: {
      title: 'File upload',
      meterCardTitle: 'Meter - {serial}',
      selectPlaceholder: 'Import type',
      importSpreadsheet: 'Import spreadsheet',
      cancel: 'Cancel',
      send: 'Send',
      emptyHint: 'Select a type and import the spreadsheet to preview the records before sending.',
      importedRecordsTitle: 'Imported records',
      qualityWarningTitle: 'Warning',
      qualityWarningDetail:
        'There are {total} record(s) without quality indicators. These records may be rejected during processing because they do not contain DRP, DRC, DTT95, FD95, or phase indicators.',
      total: 'Total',
      tableEmpty: 'No records found.',
      removeDialogTitle: 'Remove import',
      removeDialogMessage: 'Do you want to remove the file and clear the loaded data?',
      remove: 'Remove',
      sendDialogTitle: 'Confirm send',
      sendDialogMessage: 'Do you want to finalize this operation and send {total} record(s)?',
      importModalTitle: 'Import - {label}',
      types: {
        massMemory: 'Mass memory',
        quality: 'Quality parameters',
        energy: 'Energy totalizers',
        alarms: 'Alarms',
      },
      toast: {
        importedTitle: 'File imported',
        importedDetail: '{total} record(s) loaded.',
        removedTitle: 'Import removed',
        removedDetail: 'Data cleared successfully.',
        unavailableTitle: 'Unavailable',
        alarmsNotImplemented: 'This option is not available yet.',
        sentTitle: 'Sent successfully',
        sentDetail: 'Import started successfully.',
        sendError: 'Unable to send the data. Please try again.',
        noRows: 'No records were found in the file.',
        invalidSerial: 'Invalid Serial',
      },
    },
    meterVeeDetails: {
      titleWithSerial: 'VEE — Meter {serial}',
      currentReadingCardTitle: 'Current reading',
      group: 'VEE Group',
      statusCardTitle: 'Status',
      blockingCardTitle: 'Blocking',
      status: {
        ok: 'OK',
        estimated: 'Estimating',
        noCommunication: 'No communication',
        blocked: 'Blocked',
        notBlocked: 'Not blocked',
      },
      chart: {
        title: 'Readings and AMI events',
        real: 'Real',
        estimatedApproved: 'Approved estimate',
        proposed: 'Proposed',
        events: {
          interruption: 'Interruption',
          tamper: 'Tamper',
          communicationFailure: 'Communication failure',
        },
      },
      exceptions: {
        title: 'Active exceptions',
        empty: 'No active exceptions',
        edit: 'Edit',
        resolve: 'Resolve',
        status: {
          pendente: 'Pending',
          emAnalise: 'Under review',
          resolvida: 'Resolved',
          ignorada: 'Ignored',
        },
      },
      estimateProposals: {
        title: 'Estimate proposals',
        empty: 'No pending proposals',
        approve: 'Approve',
        reject: 'Reject',
      },
      editReadingDialog: {
        title: 'Edit reading',
        editReading: 'Edit reading',
        currentValue: 'Current value',
        newValue: 'New value',
        justification: 'Justification (required)',
        justificationPlaceholder: 'Describe the reason for the manual edit',
        cancel: 'Cancel',
        save: 'Save',
      },
      errors: {
        loadFailed: 'Unable to load VEE data for this meter.',
        retry: 'Try again',
      },
      toast: {
        justificationRequiredTitle: 'Justification required',
        justificationRequired: 'Enter a justification to edit the reading.',
        readingUpdatedTitle: 'Reading updated',
        readingUpdatedDetail: 'The reading was updated successfully.',
        proposalApprovedTitle: 'Estimate approved',
        proposalApprovedDetail: 'Proposal by {method} approved and applied to the current reading.',
        proposalRejectedTitle: 'Estimate rejected',
        proposalRejectedDetail: 'Proposal by {method} rejected.',
        exceptionResolvedTitle: 'Exception resolved',
        exceptionResolvedDetail: '{rule} marked as resolved.',
      },
    },
    manualInsertReadings: {
      title: 'Manual Readings/Alarms Editing',
      tabs: {
        meterAlarms: 'Meter Alarms',
        dataReadings: 'Mass Memory',
        frozenData: 'Totalizers',
        qeeIndicators: 'Quality',
        smcAlarms: 'SMC Alarms',
      },
      meterAlarmsTable: {
        serial: 'Serial',
        description: 'Description',
        terminal: 'Terminal',
        read: 'Read',
        manualInsert: 'Is manual',
        installation: 'Installation',
        user: 'User',
        translate: 'Translation',
        readDate: 'Reading Date',
        updatedAt: 'Last Update',
      },
      dataReadingsTable: {},
      frozenDataTable: {},
      qeeIndicatorsTable: {
        serial: 'Serial',
        comissioned: 'Comm',
        online: 'Online',
        dateTimeInitial: 'Initial Date/Time',
        dateTimeFinal: 'Final Date/Time',
        drp: 'DRP',
        drc: 'DRC',
        dtt95: 'DTT95',
        fd95: 'FD95',
        count: 'Count',
        meterActivated: 'Activated Meters',
        drcPhaseA: 'DrcPhaseA',
        drcPhaseB: 'DrcPhaseB',
        drcPhaseC: 'DrcPhaseC',
        drpPhaseA: 'DrpPhaseA',
        drpPhaseB: 'DrpPhaseB',
        drpPhaseC: 'DrpPhaseC',
        consumerUnitsId: 'Consumer Unit',
        updatedAt: 'Updated At',
      },
      smcAlarmsTable: {
        serial: 'Serial',
        description: 'Description',
        read: 'Read',
        isManualInsert: 'Is manual',
        user: 'User',
        translate: 'Translation',
        readDateTime: 'Reading Date/Time',
        updatedAt: 'Last Update',
      },
      messages: {
        qeeEditUnavailable: 'Editing unavailable.',
        qeeDeleteUnavailable: 'Deletion unavailable.',
        qeeClosedCycle:
          'The selected period has already been closed and does not allow manual editing. Allowed until: {deadline}.',
        qeeDeleteClosedCycle:
          'The selected period has already been closed and does not allow manual deletion. Allowed until: {deadline}.',
        invalidDateRange: 'Initial Date/Time cannot be greater than Final Date/Time.',
        requiredDrpDrc: 'DRP and DRC are required.',
        useCommaDecimalSeparator: 'Enter DRP and DRC using comma and up to 3 decimal places.',
        qeeUpdateSuccess: 'Parameter updated successfully.',
        qeeUpdateError: 'Unable to update the QEE parameter.',
        qeeDeleteConfirmTitle: 'Confirm deletion',
        qeeDeleteConfirmMessage: 'Do you really want to delete this quality parameter?',
        qeeDeleteConfirmAction: 'Delete',
        qeeDeleteSuccess: 'Quality parameter deleted successfully.',
        qeeDeleteError: 'Could not delete the quality parameter.',
      },
    },
    consumerUnit: {
      fullName: 'Full Name',
      address: 'Address',
      locationCode: 'Location Code',
      consumerUnitCode: 'Consumer Unit Code',
      situationCode: 'Situation Code',
      situationDate: 'Situation Date',
      consumptionClassCode: 'Consumption Class Code',
      equipmentNumber: 'Equipment Number',
      historyUc: 'History',
      communicationDescription: 'Communication',
      startRelationDatetime: 'Start of Relation',
      endRelationDatetime: 'End of Relation',
    },
    smcs: {
      title: 'SMCs',
      smcInfo: {
        title: 'SMC Details',
        model: 'Model',
        brand: 'Brand',
        serial: 'Serial',
        qtyMeters: 'Quantity of Clients',
        uplinkPeriod: 'Uplink Period',
        signalQuality: 'Signal',
        networkPublic: 'Public ',
        networkPrivate: 'Private ',
        description: 'Description',
        latitude: 'Latitude',
        longitude: 'Longitude',
        tagsFilterTitle: 'Applied filters',
        tagsFilterDetails: 'Tag-based filters applied; however, SMC does not have tags.',
        doorStatus: 'Door Status',
        online: 'Communication Status',
        comissioned: 'Comissioned',
      },
      criticalAlarms: {
        title: 'Critical Alerts',
        criticalAlarm: 'Critical alarm',
        readDateTime: 'Reading Time:',
        updatedAt: 'Last Update:',
        notFound: 'No critical alarms found!',
        relayFailure: 'Relay Failure',
        openDoor: 'Open Door',
        smcTimeout: 'SMC Timeout',
        lastGasp: 'Last Gasp',
        localReset: 'Local Reset',
        measurementError: 'Measurement System Error',
        keysHLSInvalid: 'Invalid HLS Keys',
        invalidMeter: 'Invalid Meter',
      },
      success: {
        createSmc: 'SMC created successfully',
        updateSmc: 'SMC updated successfully',
      },
      errors: {
        createSmc: 'Error creating SMC',
        updateSmc: 'Error updating SMC',
        loadSmcModels: 'Error loading SMC models',
      },
      summary: {
        statusTitle: 'Status',
        commissioningTitle: 'Commissioning',
        portTitle: 'Port Status',
        fetchErrorTitle: 'Error',
        fetchErrorDetail: 'Error while fetching SMC summary',
        online: 'Online',
        offline: 'Offline',
        absent: 'Absent',
        commissioned: 'Commissioned',
        notCommissioned: 'Not Commissioned',
        authorized: 'Authorized',
        unauthorized: 'Unauthorized',
        details: {
          onlineTitle: 'Online SMCs',
          offlineTitle: 'Offline SMCs',
          absentTitle: 'Absent SMCs',
          commissionedTitle: 'Commissioned SMCs',
          notCommissionedTitle: 'Not Commissioned SMCs',
          authorizedTitle: 'SMCs with Authorized port status',
          unauthorizedTitle: 'SMCs with Unauthorized port status',
          selectBrand: 'Select the brand',
        },
      },
      registerSmcFile: 'Import SMCs via file',
      editSmcFile: 'Edit SMCs via file',
      massActionStartedTitle: 'Process started',
      massActionStartedDetail: 'Process started. Please wait for the action to finish.',
    },
    modemInfo: {
      title: 'Modem',
      notAvailable: 'Not available',
      noInformation: 'No information',
      deviceEui: 'EUI',
      firmwareVersion: 'Firmware',
      signal: 'Signal',
      iccid: 'ICCID',
      imei: 'IMEI',
      imsi: 'IMSI',
      operator: 'Operator',
      cellId: 'Cell ID',
      signalQuality: 'Signal',
      bootCounter: 'Boot Counter',
      snr: 'SNR',
      rssi: 'RSSI',
      bleStack: 'BleStack',
      mcuRevision: 'MCU Revision',
      celLv: 'Cell Level',
      tempC: 'Temperature',
      rsrp: 'RSRP',
      rsrq: 'RSRQ',
      txpwr: 'TX Power',
      band: 'Band',
    },
    commands: {
      title: 'Commands',
      command: 'Command',
      notAvailable: 'Not available',
      state: 'State',
      commandQueue: 'Commands in Queue',
      noCommand: 'No Command in Queue',
      lastSeen: 'Last Communication',
      communication: 'Communication',
      noCommunication: 'Not available',
      lastCommand: 'Last Command',
      sendCommand: 'Send',
      notImplemented: 'Command not implemented',
      voltageOutIntervalMinites: 'Minute(s)',
      voltageOutIntervalHours: 'Hour(s)',
      voltageOutIntervalDays: 'Day(s)',
      sendToSelected: 'Enviar Para Selecionados',
      sendToAll: 'Enviar para todos',
      listOfCommands: {
        setSmiVoltageOutInterval: 'Set DIC/FIC Interval',
        setSmiQueeInterval: 'Set DRP/DRC Interval',
        setTariff: 'Set Tariff Type',
        updateDateTime: 'Update Date and Time',
        readDateTime: 'Read Date and Time',
        updatePeriod: 'Change Period',
        getRelay: 'Get Relay State',
        setRelayOff: 'Disconnect Relay',
        setRelayOn: 'Connect Relay',
        setReferenceVoltage: 'Reference Voltage',
        getReferenceVoltage: 'Get Reference Voltage',
        recoverActiveEnergy: 'Request Energies',
        getNetworkType: 'Get Network Type',
        setNetworkPublic: 'Switch to Public Network',
        setNetworkPrivate: 'Switch to Private Network',
        getTech: 'Get Technology',
        setNetworkCatm1: 'Switch to CATM1',
        setNetworkNbiot: 'Switch to NBIoT',
        getCellIdAndIP: 'Get Cell ID and IP',
        getHeartbeat: 'Recover Signal Quality',
        setEventQeeIndicator: 'Retrieve Quality Parameters',
        setStandartFrozenData: 'Set Standard Energies',
        setDisplayAuto: 'Set Auto Display',
        setDisplayManual: 'Set Manual Display',
        setDisplayAutoMicroMax: 'Set Auto Display MicroMax',
        setDisplayManualMicroMax: 'Set Manual Display MicroMax',
        recoverShortDurationAlarms: 'Retrieve Short Duration Alarms',
        getFiscalPage: 'Retrieve Fiscal Page',
        getLoadProfile: 'Retrieve Load Profile',
        getDailyBilling: 'Retrieve Daily Billing',
        updateDatetimeSmc: 'Update Date/Time (SMC)',
        updateDatetimeSmi: 'Update Date/Time (SMI)',
        instantMeasureSmc: 'Instant Read SMC',
        instantMeasureSmi: 'Instant Read',
        requestInstantMeasures: 'Request instant measurements',
        nicResetSmi: 'Reset NIC SMI',
        nicResetSmc: 'Reset NIC SMC',
        recoverMassMemorySmc: 'Recover Mass Memory (SMC)',
        recoverMassMemorySmi: 'Recover Mass Memory (SMI)',
        recoverEnergySmc: 'Retrieve Energy SMC',
        recoverEnergySmi: 'Retrieve Energy',
        recoverQeeIndicator: 'Recover QEE Indicator (Nepen)',
        requestRelayStatusAllSmc: 'Get SMC Relay Status',
        requestDoorStatus: 'Get Door Status',
        getVoltageOutLong: 'Get Long Interruption Alarm',
        getVoltageOutShort: 'Get Short Interruption Alarm',
        setStandardFrozenData: 'Set Standard Energy Template',
        getQeeTransparent: 'Get Transparency',
        readDisplayConfiguration: 'Read Display Configuration',
        setDisplayConfiguration: 'Set Display Configuration',
        voltageInterruptionMonthly: 'Read Voltage Interruption Monthly',
        drpDrcMonthly: 'Request Monthly DRP/DRC',
        drpDrcCycle: 'Request DRP/DRC Cycle',
        nicReset: 'Reset NIC',
        monitoring: 'Load Profile (Energy + Memory)',
        deviceReset: 'Device Reset',
        infoRequest: 'Read general info',
        requestConfiguration: 'Read configuration',
        getBlockSize: 'Get Block Size',
        imageTransferInitiate: 'Image Transfer Initiate',
        imageTransferData: 'Image Transfer Data',
        getFirstBlockNotTransferred: 'Get First Block Not Transferred',
        imageTransferVerify: 'Image Transfer Verify',
        imageTransferActivate: 'Image Transfer Activate',
        updateFirmware: 'Update Firmware',
        uploadFirmware: 'Upload Firmware',
        getHardwareInfo: 'Get Hardware Info',
        readNicInfo: 'Read Nic Info',
        readNicSetup: 'Read Nic Setup',
        readRelay: 'Read Relay',
        readTimestamp: 'Read Timestamp',
        readNicData: 'Read Nic Data',
        nicSetup: 'Nic Setup',
        readLdrUpper: 'Read Ldr Upper',
        readLdrBottom: 'Read Ldr Bottom',
        readLdrMin: 'Read Ldr Min',
        setLdrUpper: 'Set Ldr Upper',
        setLdrBottom: 'Set Ldr Bottom',
        setLdrMin: 'Set Ldr Min',
        readNicSerial: 'Read Nic Serial',
        readRelayWithLastSwitchOn: 'Read Relay With Last Switch On',
        readRelayWithLastSwitchOnAndOff: 'Read Relay With Last Switch On And Off',
        setBlockSize: 'Set Block Size',
        multicastGroupSetup: 'Multicast Group Setup',
        multicastClassCSession: 'Multicast Class C Session',
        multicastSetupConfirmation: 'Multicast Setup Confirmation',
        imageTransferStatus: 'Image Transfer Status',
        getFirmwareVersion: 'Get Firmware Version',
        readAlarmFakeOnOff: 'Read Alarm Fake OnOff',
        configureApplicationGroup: 'Configure Application Group',
        readALarmLastGasp: 'Read Alarm Last Gasp',
        setLastGaspVoltageLevel: 'Set Last Gasp Voltage Level',
        readAlarmVoltageMonitor: 'Read Alarm Voltage Monitor',
        setVoltageMinimalInterval: 'Set Voltage Minimal Interval',
        setAlarmFakeOnOffThreshold: 'Set Alarm Fake OnOff Threshold',
        readTemperatureValue: 'Read Temperature Value',
        readRelayWithDelay: 'Read Relay With Delay',
        deviceCreated: 'Device created',
        deviceUpdated: 'Device updated',
        scheduleCreated: 'Schedule created',
        scheduleUpdated: 'Schedule updated',
        groupCreated: 'Group created',
        groupUpdated: 'Group updated',
        setAlarmFakeOnOff: 'Alarm On/Off',
        scheduleCanceled: 'Schedule canceled',
        scheduleDeleted: 'Schedule deleted',
        deviceDeleted: 'Device deleted',
        groupDeleted: 'Group deleted',
        checkScheduleStatus: 'Check Schedule Status',
        activateSchedule: 'Activate schedule',
        deactivateSchedule: 'Deactivate schedule',
        checkScheduleExist: 'Check if schedule exists',
        readDeviceType: 'Read device type',
        writeDeviceRole: 'Write device role',
        fullScheduleCommand: 'Full schedule command',
        scheduleCreatedOnSystem: 'Schedule created (System)',
        activateScheduleOnSystem: 'Activate schedule (System)',
        checkScheduleStatusOnSystem: 'Check Schedule Status (System)',
        writeDeviceRoleOnSystem: 'Write device role (System)',
        deactivateScheduleOnSystem: 'Deactivate schedule (System)',
        checkScheduleExistOnSystem: 'Check if schedule exists (System)',
        readDeviceTypeOnSystem: 'Read device type (System)',
        setDatetimeOnSystem: 'Update Date and Time (System)',
        periodicConfiguration: 'Periodic Configuration',
        decommissioning: 'Decommissioning',
        openSession: 'Open Session with Meter',
        readMeterSerial: 'Read Meter Serial',
        importMassMeters: 'Import mass meters',
        saveConfig: 'Save configuration',
        readConfig: 'Read configuration',
        saveTime: 'Save datetime',
        timeCorrection: 'Time correction',
        storage: 'Storage',
        fuotaPause: 'Firmware update pause',
        deleteSpecialDays: 'Delete special days',
        getTotalizers: 'Read totalizers',
        getRelayStatusControl: 'Read Relay Status Control',
        setRelayStatusControl: 'Set Relay Status Control',
        getIntegrationInstantaneousReadings: 'Read instantaneous values',
        getVoltageOutLongShort: 'Get Voltage Out Long and short Alarm',
        relayStatusOrca: 'Recover orca relay state',
        getQeeOnDemand: 'Request quality parameters on demand',
        getQeeHistoricalData: 'Request historical data of quality parameters',
        recoverFragmentedPacket: 'Recover fragmented data',
        drpDrcEventLog: 'DRP and DRC Event Log',
        readTariffPeriods: 'Get Tariff Reading',
        smartFuseAlarmAck: 'Alarm Ack',
        getCollectiveCutStatus: 'Get Collective Cut Status',
        sendRollback: 'Send RollBack',
        disableCollectiveCut: 'Enable Collective Cut',
        enableCollectiveCut: 'Disable Collective Cut',
        relayOnAllMeterSmc: 'Relog All Clients',
        getStatus: 'Get Relay Status',
        activate: 'Activate Relay',
        disable: 'Disable Relay',
        requestMeters: 'Request Meters',
        getTariffReading: 'Get Tariff Type',
      },
      placeholders: {
        selectCommand: 'Select a command',
        sendToSelected: 'Send to Selected',
      },
      messagesSuccess: {
        success: 'Success',
        commandSent: 'Command sent successfully!',
        commandExecuted: 'Command executed successfully!',
      },
      messagesErrors: {
        error: 'Error',
        commandSent: 'Error sending command',
        commandExecuted: 'Error executing command',
        errorVerifyCommandCondition: 'Error verifying command condition',
        errorFilterCommands: 'Error filtering available commands',
        commandExecutedTryAgain: 'It was not possible to execute the command.\nTry again later.',
        commandExecutedPartial: 'The commands were executed partially.',
        commandExecutedPartialNotExecute: ' did not execute.',
      },
    },
    dataExtraction: {
      title: 'Data extraction',
      cardTitle: 'Bulk data extraction',
      dateRangePlaceholder: 'Select the period',
      dateRangeTooltip: 'Enter a period of no more than 30 days',
      selectPlaceholder: 'Export type',
      consult: 'Search',
      serialLabel: 'Serial',
      serialsPlaceholder:
        'Enter one serial per line, or separate them by comma, space, or semicolon. This field is optional. You can adjust which information you want to extract according to the selected filters. Only export type and date range are required; serial and client are optional.',
      serialsHint: 'Total valid serials: {total}',
      previewTitle: 'Records preview',
      tableEmpty: 'No records found',
      noResults: 'No records were found for the selected filters.',
      previewError: 'Error while loading extraction preview.',
      maxRangeExceededError: 'The selected range must be no more than 30 days.',
      maxRangeFutureDateError: 'The end date cannot be later than today.',
      filter: {
        typeLabel: 'Export type',
        periodLabel: 'Period',
        clientLabel: 'Client',
        clientPlaceholder: 'Select a client',
        validationMessage:
          'Specify the export type and the period. Serial and client are optional.',
      },
      types: {
        massMemory: 'Mass memory',
        energy: 'Energy',
        alarms: 'Alarms',
        latestQualityParameters: 'Latest quality parameters',
        qualityDicFic: 'Quality parameters - DIC/FIC',
        qualityDrpDrc: 'Quality parameters - DRP/DRC',
      },
      clearFiltersDialog: {
        title: 'Clear filters',
        message: 'Do you really want to clear the filters and the data preview?',
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      summary: {
        warning: 'Warning',
        info: 'Information',
        success: 'Success',
        error: 'Error',
      },
      importSpreadsheet: {
        button: 'Import spreadsheet',
        downloadModel: 'Download model',
        noFileSelected: 'No file selected.',
        serialWhitespaceError: 'Rows {rows} of the file have invalid whitespace in the serial.',
        emptySerialError: 'The file contains rows with an empty Serial field.',
        noValidSerials: 'No valid serials were found in the spreadsheet.',
        fileProcessError: 'Error processing file.',
        importSuccess: '{total} serial(s) imported from the spreadsheet successfully.',
      },
    },
    firmware: {
      title: 'Firmware Version',
      version: 'Firmware Version',
      registerFirmware: 'New Version',
      editFirmware: 'Edit Firmware',
      registerFirmwareFile: 'Import Firmwares Through File',
      editFirmwareFile: 'Edit Firmwares Through File',

      success: {
        getFirmwares: 'Firmwares searched successfully',
      },
      errors: {
        getFirmwares: 'Error searching firmwares',
      },
    },
    keys: {
      title: 'Keys',
      importKeys: 'Import Keys',
      editKeysInBulk: 'Edit Keys in Bulk',
      registerKeysInBulk: 'Register Keys in Bulk',
      periodPlaceholder: 'Select the period',
      success: {
        getKeys: 'Keys searched successfully',
        createKey: 'Key created successfully',
        updateKey: 'Key updated successfully',
        addMassKeys: 'Keys registration request sent',
      },
      errors: {
        getKeys: 'Error searching keys',
        createKey: 'Error creating key',
        updateKey: 'Error updating key',
        addMassKeys: 'Error sending command',
        convertKey: 'Error converting key to hexadecimal',
      },
      toasts: {
        importSuccess: 'Import completed successfully',
        importSuccessDetail: 'All keys have been imported successfully',
        importPartial: 'Import partially completed',
        importPartialDetail: 'key imported successfully, | keys imported successfully,',
        importError: 'Error importing keys',
        editSuccess: 'Edit completed successfully',
        editSuccessDetail: 'All keys have been edited successfully',
        editPartial: 'Edit partially completed',
        editPartialDetail: 'key edited successfully, | keys edited successfully,',
        editError: 'Error editing keys',
        failed: 'failed | failed',
      },
    },
    tags: {
      title: 'Tags',
      newTag: 'New Tag',
      success: {
        getTags: 'Tags searched successfully',
        createTag: 'Tag created successfully',
        updateTag: 'Tag updated successfully',
        deleteTag: 'Tag deleted successfully',
      },
      errors: {
        getTags: 'Error searching tags',
        createTag: 'Error creating tag',
        updateTag: 'Error updating tag',
        deleteTag: 'Error deleting tag',
      },
    },
    clients: {
      client: 'Client',
      clients: 'Clients',
      clientDetails: 'Client Details',
      editClient: 'Edit Client',
      fullName: 'Full Name',
      location: 'Location',
      updatedAt: 'Updated At',
      metersTableTitle: 'Meters of Client',
      addMeters: 'Add Meters',
      removeMeters: 'Remove Meters',
      removeMetersDescription:
        'Are you sure you want to remove the selected meters from this client?',
      confirmRemoveMeters: 'Yes, remove',
      weights: 'Weights',
      prefixUf: 'UF Prefix',
      bulkLink: 'Bulk link',
      manageLinks: 'Manage links',
      linkedUsers: 'Linked users',
      unlinkSelected: 'Unlink selected',
      associateClients: 'Associate clients',
      addToTenant: 'Add user',
      removeFromTenant: 'Remove from client',
      userAdded: 'User added to client.',
      userRemoved: 'User removed from client.',
      newUser: 'New User',
      editUser: 'Edit user',
      bulkLinkHeader: 'Bulk link user to clients',
      manageLinkHeader: 'Manage user links',
      unlinkConfirm: 'Unlink Selected',
      selectUser: 'Select a user',
      selectClients: 'Select clients',
      link: 'Link',
      errorLoadingClients: 'Error loading clients',
      deleteClients: 'Delete clients',
      noClientSelected: 'No client selected',
      linksTitle: 'Links',
      clientsLinked: '{count} client(s) linked.',
      clientsLinkFailed: '{count} failed.',
      errorLinkingClients: 'Error linking clients.',
      unlinked: 'Unlinked.',
      countUnlinked: '{count} unlinked.',
      errorUnlinking: 'Error unlinking.',
      goToBulkLink: 'Go to bulk link',
      goToManageLinks: 'Go to manage links',
      userCreated: 'User created successfully.',
      errorCreatingUser: 'Error creating user',
    },
    users: {
      title: 'Users',
      user: 'User',
      newUser: 'New User',
      editUser: 'Edit user',
      yourAccountTab: 'Your Account',
      allUsersTab: 'All Users',
      lastUpdateLabel: 'Last Update',
      confirmDelete: 'Confirm user deletion',
      userEdited: 'User edited successfully.',
      userAddedToClient: 'User added to client.',
      errorAddingUser: 'Error adding user',
      userUnlocked: 'User unlocked successfully.',
      errorFetchingUsers: 'Error fetching users',
      noUserSelected: 'No user selected',
      deleteUsers: 'Delete users',
      removeUsers: 'Remove users',
      countRemoved: '{count} removed from client.',
      countFailed: '{count} failed.',
      usernameLabel: 'Username',
      typeColumnLabel: 'Type',
      usernamePlaceholder: 'Enter username',
      grantAccess: 'Grant Access',
      createUser: 'Create',
      userTypeLabel: 'Authentication Type',
      userTypeNormal: 'Normal',
      userTypeLdap: 'LDAP',
      userExists: 'User found in the system.',
      userNotFound: 'User not found. Fill in the details to create.',
      nameLabel: 'Name',
      emailLabel: 'Email',
      emailPlaceholder: 'Enter email',
      passwordLabel: 'Password',
      confirmPasswordLabel: 'Confirm password',
      descriptionLabel: 'Description',
      roleLabel: 'Role',
      receiveEmailsLabel: 'Receive emails',
      selectRolePlaceholder: 'Select a role',
      optionalPlaceholder: 'Optional',
      passwordOptionalPlaceholder: 'Leave blank to keep the current password',
      updateButton: 'Update',
      invalidEmail: 'Invalid email.',
      nameMinLength: 'Name must contain at least 4 letters.',
      passwordRequirements:
        'Password must contain at least 8 characters, one uppercase and one lowercase letter.',
      passwordMismatch: 'Passwords do not match.',
      clientLabel: 'Client links',
      noClientPlaceholder: 'No link',
      ldapOnly: 'LDAP only',
      statusHeader: 'Status',
      blocked: 'Blocked',
      active: 'Active',
      loginTypeHeader: 'Login type',
      updated: 'User updated successfully.',
      errorUpdatingUser: 'Error updating user.',
      noClients: 'No clients linked.',
      addClientPlaceholder: 'Add clients...',
    },
    veeGroups: {
      title: 'VEE Groups',
      tableTitle: 'VEE Groups',
      actions: {
        newGroup: 'New VEE Group',
      },
      columns: {
        name: 'Name',
        purpose: 'Purpose',
        scope: 'Scope',
        mode: 'Mode',
        period: 'Validity',
        frequency: 'Frequency',
        priority: 'Priority',
        rules: 'Rules',
        status: 'Status',
        actions: 'Actions',
      },
      filters: {
        searchLabel: 'Search by name or description',
        searchPlaceholder: 'Quick search',
        purpose: 'Purpose',
        status: 'Status',
        scope: 'Data scope',
        mode: 'Operational mode',
        referenceDate: 'Reference date',
        referenceDatePlaceholder: 'Select the reference date',
        selectOption: 'Select',
      },
      status: {
        active: 'Active',
        inactive: 'Inactive',
      },
      scopes: {
        massMemory: 'Mass Memory',
        totalizers: 'Totalizers',
        both: 'Hybrid',
      },
      modes: {
        gate: 'Gate',
        consultative: 'Consultative',
      },
      purpose: {
        billing: 'Billing Validation',
        monitoring: 'Operational Monitoring',
      },
      retentionLevel: {
        reading: 'Reading',
        channel: 'Channel',
        cycle: 'Cycle',
        meter: 'Meter',
      },
      period: {
        openEnded: 'Open',
      },
      details: {
        loadingTitle: 'Loading VEE Group...',
        breadcrumbTitle: 'VEE Group Details',
        badge: 'Operation/consult',
        inDevelopment: 'Feature in development',
        sections: {
          configuration: 'VEE Group Configuration',
          fallback: 'Estimation Configuration (Fallback)',
          pipeline: 'Pipeline',
          readingHistory: 'Reading History',
          groupMeters: 'Group meters',
          pendingEstimates: 'Pending estimation proposals',
        },
        labels: {
          historicalWindow: 'Historical Window',
        },
        fallbackSettings: {
          caption:
            'Reorder fallback methods and adjust the historical window using the current contract.',
          savingTitle: 'Saving...',
          saving: 'Saving fallback settings...',
          successTitle: 'Success',
          success: 'Fallback settings updated successfully',
          errorTitle: 'Error',
          error: 'Error updating fallback settings',
        },
        actions: {
          retry: 'Try again',
          backToList: 'Back to VEE Groups',
          configureGroup: 'Configure group',
          approveSelected: 'Approve selected',
          reject: 'Reject',
        },
        empty: {
          fallback: 'No fallback configured.',
        },
        summary: {
          notAvailable: '-',
          caption: 'Operational summary with real data already available in the group details.',
          labels: {
            group: 'Group',
            scope: 'Type/Scope',
            objective: 'Objective',
            mode: 'Mode',
            lastExecution: 'Last execution',
            priority: 'Priority',
            frequency: 'Frequency',
            period: 'Period',
            status: 'Status',
          },
        },
        configuration: {
          caption: 'Scope, validity, mode, blocking policy, and group resolution level.',
          labels: {
            scope: 'Group scope',
            validity: 'Validity',
            mode: 'Gate/Consultative mode',
            blockingPolicy: 'Blocking policy',
            resolutionLevel: 'Hierarchical resolution level',
            frequency: 'Frequency',
          },
          blockingPolicies: {
            none: 'Not applicable',
            blockOnOpenException: 'Block on open exception',
          },
        },
        errors: {
          title: 'Error loading VEE Group',
          load: 'Error loading VEE Group',
          groupNotFound: 'Group not found',
        },
        pipeline: {
          caption:
            'Local visual pipeline preview while the native rule library and the real flow are not implemented yet.',
          columns: {
            name: 'Name',
            lastExecution: 'Last execution',
            actions: 'Actions',
          },
        },
        readingHistory: {
          real: 'Real',
          approvedEstimated: 'Approved estimate',
          proposed: 'Proposed',
          previewHint:
            'Local preview for group details with three visual series: real, approved estimate, and proposed.',
        },
        meters: {
          openTab: 'Open VEE tab',
          previewHint:
            'Local visual preview while opening the meter VEE tab remains in a future activity.',
          columns: {
            serial: 'Meter',
            note: 'Note',
            state: 'State',
            actions: 'Actions',
          },
          notes: {
            stableReadings: 'Meter with consistent real readings across the latest windows.',
            approvedInterpolation: 'Latest interval with an approved interpolation estimate.',
            noCommunication: 'No communication in the most recent group period.',
            withPendency: 'Meter with an estimation proposal awaiting approval.',
            blocked: 'Meter blocked for billing until the exception is resolved.',
          },
          states: {
            ok: 'OK',
            estimated: 'Estimated',
            noCommunication: 'No communication',
            withPendency: 'With pendency',
            blocked: 'Blocked',
          },
        },
        pendingEstimates: {
          previewHint:
            'Local visual preview of this group pending proposals, without implementing a new operational flow.',
          summary: '{count} pending proposals',
          summaryCaption: 'Most recurring methods: interpolation, proxy day, and load profile.',
          pendingStatus: 'Pending',
          labels: {
            method: 'Method',
            proposedValue: 'Proposed value',
          },
          columns: {
            status: 'Status',
          },
        },
      },
      form: {
        createTitle: 'Create VEE Group',
        editTitle: 'Edit VEE Group',
        fields: {
          name: 'Group name',
          purposeCode: 'Purpose',
          dataScope: 'Data scope',
          period: 'Period',
          effectiveFrom: 'Validity start',
          effectiveTo: 'Validity end',
          fallback: 'Fallback',
          historicalWindow: 'Historical window',
          blockingPolicyCode: 'Billing trigger',
          executionFrequency: 'Execution frequency',
          operationalMode: 'Mode',
          priority: 'Priority (1-10)',
        },
        placeholders: {
          name: 'Group name',
          effectiveFrom: 'Select',
          effectiveTo: 'Select',
          blockingPolicyCode: 'Billing trigger',
          select: 'Select',
        },
        frequency: {
          immediate: 'On Demand',
          dailyDigest: 'Daily Digest',
          weeklyDigest: 'Weekly Digest',
        },
        fallback: {
          interpolation: 'Interpolation',
          proxyDay: 'Proxy Day',
          loadProfile: 'Load Profile',
          scalarCalculation: 'Scalar Calculation',
          moveUp: 'Move fallback up',
          moveDown: 'Move fallback down',
          sevenDays: '7 days',
          fifteenDays: '15 days',
          oneMonth: '1 month',
        },
        priorityScale: {
          low: 'Low',
          medium: 'Medium',
          high: 'High',
        },
        actions: {
          cancel: 'Cancel',
          save: 'Save',
          saving: 'Saving',
        },
        messages: {
          saveNotAvailableTitle: 'Flow in progress',
          saveNotAvailableDetail:
            'Saving the VEE Group will be implemented in the next micro-activities.',
        },
        validation: {
          title: 'Warning',
          summary: 'Review the highlighted fields before saving',
          required: 'Required field',
          nameRequired: 'Group name is required',
          purposeRequired: 'Purpose is required',
          dataScopeRequired: 'Data scope is required',
          effectiveFromRequired: 'Start date is required',
          invalidPeriod: 'End date must be greater than or equal to the start date',
          blockingPolicyCodeRequired: 'Billing trigger is required in Gate mode',
          executionFrequencyRequired: 'Execution frequency is required',
          operationalModeRequired: 'Mode is required',
          priorityRange: 'Priority must be between 1 and 10',
        },
      },
      errors: {
        title: 'Error',
        loadList: 'Error loading VEE groups',
        create: 'Error creating VEE Group',
        update: 'Error updating VEE Group',
        deactivate: 'Error deactivating VEE Group',
      },
      success: {
        title: 'Success',
        create: 'VEE Group created successfully',
        update: 'VEE Group updated successfully',
        deactivate: 'VEE Group deactivated successfully',
      },
      deactivateDialog: {
        title: 'Confirm deactivation',
        description: 'Do you really want to deactivate this VEE Group?',
        confirm: 'Deactivate',
      },
      placeholderDialog: {
        title: 'Flow in progress',
        close: 'Close',
        messages: {
          view: 'The VEE Group details view will be implemented in the next micro-activities.',
          inactivate:
            'The VEE Group deactivation flow will be implemented in the next micro-activities.',
        },
      },
    },
    veeConfiguration: {
      groupDetails: {
        loadingTitle: 'Loading configuration...',
        breadcrumbTitle: 'VEE Group Configuration',
        pageTitlePrefix: 'VEE Configuration',
        actions: {
          backToDetails: 'Back to Group Details',
          retry: 'Try again',
        },
        sections: {
          identification: 'Scope, validity, mode, blocking, hierarchical level and frequency',
          pipeline: 'Rule Pipeline',
          fallback: 'Estimation - fallback and historical window',
        },
        labels: {
          scope: 'Scope',
          validity: 'Validity',
          mode: 'Mode',
          blockingPolicy: 'Blocking policy',
          resolutionLevel: 'Hierarchical resolution level',
          frequency: 'Frequency',
        },
        blockingPolicyOptions: {
          perMeter: 'Per whole meter',
          perReadingPeriod: 'Per reading period',
          alertOnly: 'Alert only',
        },
        pipeline: {
          caption:
            'Local preview of the pipeline while the native rule library (activity 008) is not yet available.',
          columns: {
            order: 'Order',
            rule: 'Rule',
            severity: 'Severity',
            action: 'Action',
            validity: 'Validity',
            actions: 'Actions',
          },
          severities: {
            info: 'Info',
            issue: 'Issue',
            terminate: 'Terminate',
          },
          actions: {
            alert: 'Alert only',
            hold: 'Hold',
            blockBilling: 'Block billing',
            stopPipeline: 'Stop pipeline',
          },
          crud: {
            create: 'Create Pipeline',
            edit: 'Edit',
            delete: 'Delete',
          },
          form: {
            createTitle: 'Create Pipeline Rule',
            editTitle: 'Edit Pipeline Rule',
            fields: {
              rule: 'Rule',
              severity: 'Severity',
              action: 'Action',
              effectiveFrom: 'Validity start',
              effectiveTo: 'Validity end',
            },
            placeholders: {
              select: 'Select',
              effectiveFrom: 'Validity start date',
              effectiveTo: 'Validity end date',
            },
            validation: {
              ruleRequired: 'Select a rule for the pipeline',
              effectiveFromRequired: 'Validity start is required',
              invalidPeriod: 'Validity end cannot be earlier than validity start',
            },
          },
          deleteDialog: {
            title: 'Delete pipeline rule',
            description: 'This action will remove the selected rule from the pipeline.',
            confirm: 'Delete',
          },
          toast: {
            created: 'Pipeline rule created successfully',
            updated: 'Pipeline rule updated successfully',
            deleted: 'Pipeline rule deleted successfully',
          },
        },
        errors: {
          title: 'Error loading configuration',
          load: 'Error loading the group configuration',
          groupNotFound: 'Group not found',
        },
      },
      rulesLibrary: {
        pageTitle: 'VEE Configuration - Rule Library',
        breadcrumbTitle: 'Rule Library',
        tableTitle: 'Rule Library',
        columns: {
          name: 'Rule',
          scope: 'Scope',
          cost: 'Cost',
          status: 'Status',
          actions: 'Action',
        },
        actions: {
          create: 'Create rule',
          thresholds: 'Thresholds',
          thresholdsTooltip: 'Configure rule thresholds',
          edit: 'Edit',
          delete: 'Delete',
        },
        filters: {
          searchPlaceholder: 'Quick search',
          scope: 'Scope',
          cost: 'Cost',
          status: 'Status',
          severity: 'Severity',
          selectOption: 'Select',
        },
        form: {
          createTitle: 'Create Rule',
          editTitle: 'Edit Rule',
          fields: {
            name: 'Rule',
            description: 'Description',
            scope: 'Scope',
            dataType: 'Data type',
            defaultSeverity: 'Default severity',
            defaultAction: 'Default operational action',
            cost: 'Cost',
            status: 'Status',
          },
          placeholders: {
            name: 'Rule name',
            description: 'Short rule description',
            select: 'Select',
          },
          validation: {
            nameRequired: 'Enter the rule name',
          },
          actions: {
            cancel: 'Cancel',
            save: 'Save',
          },
        },
        deleteDialog: {
          title: 'Delete rule',
          description: 'This action is only a visual simulation, no rule will actually be removed.',
          confirm: 'Delete',
        },
        toast: {
          created: 'Rule created successfully',
          updated: 'Rule updated successfully',
          deleted: 'Rule deleted successfully',
        },
      },
      ruleThresholds: {
        dialogTitle: 'Rule Thresholds',
        labels: {
          rule: 'Rule',
          upperLimit: 'Upper limit (%)',
          lowerLimit: 'Lower limit (%)',
          basis: 'Calculation basis',
          seasonality: 'Seasonality',
        },
        basisOptions: {
          absolute: 'Absolute',
          historical: 'Historical-based',
        },
        placeholders: {
          selectRule: 'Select the rule',
        },
        validation: {
          lowerGreaterThanUpper: 'The lower limit cannot be greater than the upper limit',
        },
        actions: {
          cancel: 'Cancel',
          save: 'Save',
        },
        toast: {
          saved: 'Configuration saved successfully',
        },
      },
      billingCalendar: {
        pageTitle: 'VEE Configuration - Billing Calendar',
        breadcrumbTitle: 'Billing Calendar',
        tableTitle: 'Billing Calendar',
        columns: {
          group: 'Group',
          readingDay: 'Reading day',
          closingDay: 'Closing date',
          triggerDMinusN: 'D-N trigger',
          status: 'Status',
          actions: 'Actions',
        },
        statusOptions: {
          ready: 'Ready',
          pending: 'Pending',
          blocked: 'Blocked',
        },
        labels: {
          group: 'Group',
          readingDay: 'Reading day',
          closingDay: 'Closing date',
          triggerDMinusN: 'D-N trigger',
        },
        placeholders: {
          selectDay: 'Select the day',
          searchPlaceholder: 'Quick search',
        },
        filters: {
          status: 'Status',
          selectOption: 'Select',
        },
        form: {
          createTitle: 'Create Calendar',
          editTitle: 'Edit Calendar',
          actions: {
            create: 'Register Billing',
            cancel: 'Cancel',
            save: 'Save',
            edit: 'Edit',
            delete: 'Delete',
          },
        },
        deleteDialog: {
          title: 'Delete calendar',
          description:
            'This action is only a visual simulation, no calendar will actually be removed.',
          confirm: 'Delete',
        },
        toast: {
          created: 'Calendar created successfully',
          updated: 'Calendar updated successfully',
          deleted: 'Calendar deleted successfully',
        },
      },
      notifications: {
        pageTitle: 'VEE Configuration - Notifications',
        breadcrumbTitle: 'Notifications',
        tableTitle: 'Notifications',
        columns: {
          group: 'Group',
          frequency: 'Frequency',
          recipients: 'Recipients',
          escalationChannel: 'Escalation channel',
          eventTypes: 'Event types',
          status: 'Status',
          actions: 'Actions',
        },
        labels: {
          veeGroup: 'VEE Group',
          frequency: 'Frequency',
          groupRecipients: 'Recipients per group',
          escalationChannel: 'Escalation channel (critical billing readiness)',
          eventTypes: 'Monitored event types',
        },
        placeholders: {
          searchPlaceholder: 'Quick search',
          selectVeeGroup: 'Select the VEE group',
        },
        filters: {
          frequency: 'Frequency',
          status: 'Status',
          selectOption: 'Select',
        },
        form: {
          createTitle: 'Create Notification',
          editTitle: 'Edit Notification',
          actions: {
            create: 'Create notification',
            cancel: 'Cancel',
            save: 'Save',
            edit: 'Edit',
            delete: 'Delete',
          },
        },
        deleteDialog: {
          title: 'Delete notification',
          description:
            'This action is only a visual simulation, no notification will actually be removed.',
          confirm: 'Delete',
        },
        validation: {
          invalidEmail: 'Enter a valid email address',
          veeGroupRequired: 'Select the VEE group',
        },
        toast: {
          created: 'Notification created successfully',
          updated: 'Notification updated successfully',
          deleted: 'Notification deleted successfully',
        },
      },
      hierarchyAssociation: {
        pageTitle: 'VEE Configuration - Hierarchy Association',
        breadcrumbTitle: 'Hierarchy Association',
        tableTitle: 'Hierarchy Association',
        columns: {
          level: 'Level',
          criterion: 'Criterion',
          appliedGroup: 'Applied group',
          priority: 'Priority',
          validity: 'Validity',
          status: 'Status',
          actions: 'Actions',
        },
        statusOptions: {
          active: 'Active',
          inactive: 'Inactive',
        },
        levelOptions: {
          meter: 'Meter',
          meterGroup: 'Meter group',
          tariffClass: 'Tariff class',
          technology: 'Technology',
          default: 'Default',
        },
        actions: {
          create: 'Create association',
          edit: 'Edit',
          delete: 'Delete',
        },
        filters: {
          searchPlaceholder: 'Quick search',
          level: 'Level',
          status: 'Status',
          selectOption: 'Select',
        },
        form: {
          createTitle: 'Create Association',
          editTitle: 'Edit Association',
          fields: {
            level: 'Level',
            criterion: 'Criterion',
            appliedGroup: 'Applied group',
            priority: 'Priority',
            effectiveFrom: 'Validity start',
            effectiveTo: 'Validity end',
            status: 'Status',
          },
          placeholders: {
            criterion: 'Enter the criterion',
            select: 'Select',
            effectiveFrom: 'Start date',
            effectiveTo: 'End date',
          },
          validation: {
            criterionRequired: 'Enter the criterion',
            effectiveFromRequired: 'Validity start is required',
            invalidPeriod: 'Validity end cannot be earlier than validity start',
          },
          actions: {
            cancel: 'Cancel',
            save: 'Save',
          },
        },
        deleteDialog: {
          title: 'Delete association',
          description:
            'This action is only a visual simulation, no association will actually be removed.',
          confirm: 'Delete',
        },
        toast: {
          created: 'Association created successfully',
          updated: 'Association updated successfully',
          deleted: 'Association deleted successfully',
        },
      },
      customRule: {
        pageTitle: 'VEE Configuration - Custom Rule',
        breadcrumbTitle: 'Custom Rule',
        sections: {
          condition: 'Custom Rule',
          sandbox: 'Sandbox',
          dryRun: 'Dry run - impact',
        },
        labels: {
          condition: 'Condition',
          operator: 'Operator',
          value: 'Value',
          window: 'Window',
          period: 'Period',
          action: 'Operational action',
          sandboxGroup: 'Sample',
          summary: 'Rule summary',
        },
        actions: {
          runTest: 'Run test',
          activate: 'Activate in production',
        },
        dryRun: {
          affectedMeters: 'Affected meters',
          sampleExceptions: 'Sample exceptions',
        },
        toast: {
          testRun: 'Test executed successfully. You can now activate the rule in production.',
          activated: 'Operation completed successfully',
        },
      },
    },
    veeGroupsLegacy: {
      title: 'VEE Groups',
      tableTitle: 'Group listing',
      actions: {
        newGroup: 'New VEE Group',
      },
      columns: {
        name: 'Name',
        purpose: 'Purpose',
        scope: 'Scope',
        mode: 'Mode',
        period: 'Validity',
        frequency: 'Frequency',
        priority: 'Priority',
        rules: 'Rules',
        status: 'Status',
        actions: 'Actions',
      },
      filters: {
        searchLabel: 'Search by name or description',
        searchPlaceholder: 'Type name or description',
        purpose: 'Purpose',
        status: 'Status',
        scope: 'Data scope',
        mode: 'Operational mode',
        referenceDate: 'Reference date',
        referenceDatePlaceholder: 'Select the reference date',
        selectOption: 'Select',
      },
      status: {
        active: 'Active',
        inactive: 'Inactive',
      },
      scopes: {
        massMemory: 'Mass Memory',
        totalizers: 'Totalizers',
        both: 'Hybrid',
      },
      modes: {
        gate: 'Gate',
        consultative: 'Consultative',
      },
      purpose: {
        billing: 'Billing Validation',
        monitoring: 'Operational Monitoring',
      },
      formDialog: {
        createTitle: 'New VEE Group',
        editTitle: 'Edit VEE Group',
        name: 'Name',
        description: 'Description',
        frequency: 'Frequency',
        frequencyOptions: {
          daily: 'Daily',
          weekly: 'Weekly',
          monthly: 'Monthly',
        },
        priority: 'Priority',
        period: 'Validity',
        cancel: 'Cancel',
        save: 'Save',
        nameRequired: 'Enter a name for the group.',
      },
      detailsDialog: {
        title: 'VEE Group Details',
        close: 'Close',
      },
      inactivateDialog: {
        title: 'Deactivate VEE Group',
        message: 'Are you sure you want to deactivate group "{name}"?',
        cancel: 'Cancel',
        confirm: 'Deactivate',
      },
      toasts: {
        createSuccess: 'VEE Group created successfully.',
        editSuccess: 'VEE Group updated successfully.',
        inactivateSuccess: 'VEE Group deactivated successfully.',
      },
    },
    veeResume: {
      title: 'VEE Monitoring — Summary',
      badge: 'Operation/inquiry',
      cards: {
        batchProcessed: 'Batch processed (%)',
        metersCompleted: 'Meters completed',
        estimatesToApprove: 'Estimates to approve',
        blocks: 'Blocks',
      },
      billingReadiness: {
        title: 'Billing readiness',
        empty: 'No meters found.',
        columns: {
          meter: 'Meter',
          status: 'Status',
          pending: 'Pending items',
          action: 'Recommended action',
        },
        status: {
          ready: 'Ready',
          pending: 'Pending',
          blocked: 'Blocked',
        },
        units: {
          estimates: 'estimates',
          critical: 'critical',
        },
        actions: {
          approveEstimates: 'Approve estimates',
          reviewBlock: 'Review block',
        },
        noPending: '—',
        actionDialog: {
          approveTitle: 'Approve estimates',
          reviewTitle: 'Review block',
          approveMessage: 'Confirm approval of {count} estimate(s) for meter {meter}?',
          reviewMessage: 'Confirm resolution of the critical block for meter {meter}?',
          cancel: 'Cancel',
          confirm: 'Confirm',
          approveSuccess: 'Estimates for meter {meter} approved successfully.',
          reviewSuccess: 'Block for meter {meter} resolved successfully.',
          justification: 'Justification (required to unblock)',
          justificationPlaceholder: 'Describe the reason for manually unblocking billing',
          columns: {
            item: 'Item',
            value: 'Estimated value',
          },
        },
      },
      calendar: {
        title: 'Monthly calendar',
        configureTooltip: 'Configure billing calendar',
        legend: {
          ready: 'Ready',
          pending: 'Pending',
          blocked: 'Blocked',
          note: '(with group label)',
        },
        weekDays: {
          sunday: 'Sun',
          monday: 'Mon',
          tuesday: 'Tue',
          wednesday: 'Wed',
          thursday: 'Thu',
          friday: 'Fri',
          saturday: 'Sat',
        },
      },
    },
    veeBatchApproval: {
      title: 'VEE Monitoring — Batch Approval',
      badge: 'Operation/inquiry · supervisor',
      filters: {
        title: 'Filters',
        group: 'Group',
        selectGroup: 'Select the group',
        region: 'Region',
        selectRegion: 'Select the region',
        method: 'Method',
        selectMethod: 'Select the method',
        period: 'Period',
        selectPeriod: 'Select the period',
        clear: 'Clear',
        apply: 'Apply',
      },
      table: {
        title: 'Estimates pending approval',
        empty: 'No estimates pending approval.',
        columns: {
          meter: 'Meter',
          method: 'Method',
          proposedValue: 'Proposed value',
          deviation: 'Deviation',
        },
      },
      actions: {
        reject: 'Reject selected',
        approve: 'Approve selected',
      },
      toasts: {
        approveSummary: 'Estimates approved',
        approveDetail: '{count} estimate(s) approved successfully.',
        rejectSummary: 'Estimates rejected',
        rejectDetail: '{count} estimate(s) rejected.',
        noSelectionSummary: 'No estimate selected',
        noSelectionDetail: 'Select at least one estimate to continue.',
        highRiskGroupSummary: 'Bulk approval not allowed',
        highRiskGroupDetail:
          'Group A - High Voltage meters require individual approval on the meter VEE tab, not in bulk.',
        processingErrorSummary: 'Failed to process part of the selection',
        processingErrorDetail: '{count} meter(s) could not be processed and remain selected.',
      },
    },
    veeReadingImport: {
      title: 'VEE Monitoring — Reading Import',
      badge: 'Operation/inquiry',
      downloadTemplate: 'Download template',
      importSpreadsheet: 'Import spreadsheet',
      importDialogTitle: 'Import Readings',
      dropzone: 'Drag the file here or click to select',
      empty: 'No file imported yet.',
      columns: {
        line: 'Line',
        meter: 'Meter',
        value: 'Value',
        result: 'Result',
      },
      results: {
        ok: 'OK',
        suggestion: 'Suggestion: {value}',
        rejected: 'Rejected',
      },
      confirm: 'Accept suggestions and confirm',
      toasts: {
        emptyFile: 'No rows found in the imported file.',
        validatedSummary: 'File validated',
        validatedDetail: 'Row-by-row validation completed. Review the result before confirming.',
        confirmedSummary: 'Import confirmed',
        confirmedDetail: '{suggestions} correction suggestion(s) accepted automatically.',
      },
    },
    veeRequestQueue: {
      title: 'VEE Monitoring — Request Queue',
      badge: 'Operation/inquiry',
      empty: 'No pending requests.',
      columns: {
        meter: 'Meter',
        issue: 'Issue',
        slaRemaining: 'SLA remaining',
        actions: 'Actions',
      },
      actions: {
        createOrder: 'Create order',
        edit: 'Edit',
      },
      actionDialog: {
        cancel: 'Cancel',
        confirm: 'Confirm',
      },
      createOrderDialog: {
        title: 'Create Service Order',
        technician: 'Responsible team',
        priority: 'Priority',
        dueDate: 'Due date',
        priorities: {
          low: 'Low',
          medium: 'Medium',
          high: 'High',
        },
        successSummary: 'Service order created successfully for meter {meter}.',
      },
      editDialog: {
        title: 'Edit estimate',
        newValue: 'New value',
        note: 'Note',
        successSummary: 'Estimate for meter {meter} updated successfully.',
        invalidValueTitle: 'Invalid value',
        invalidValueDetail: 'Enter a new value greater than zero.',
        justificationRequiredTitle: 'Note required',
        justificationRequiredDetail: 'Describe the reason for the change before confirming.',
      },
    },
    veeZeroConsumption: {
      title: 'VEE Monitoring — Prolonged Zero Consumption',
      badge: 'Operation/inquiry',
      affectedMeters: 'Affected meters',
      empty: 'No meters with zero consumption.',
      columns: {
        meter: 'Meter',
        zeroSince: 'Zero since',
        duration: 'Duration',
        vacant: 'Vacant',
        action: 'Action',
      },
      actions: {
        checkField: 'Check field',
      },
      checkDialog: {
        title: 'Check field',
        message: 'What was the result of the field check for meter {meter}?',
        outcomes: {
          vacant: 'Confirm vacancy',
          defective: 'Meter is defective',
          resumed: 'Consumption resumed',
        },
        cancel: 'Cancel',
        confirm: 'Confirm',
        successSummary: 'Field check for meter {meter} recorded successfully.',
      },
    },
    veeLimitDeviations: {
      title: 'VEE Monitoring — Limit Deviations',
      badge: 'Operation/inquiry',
      empty: 'No deviations found.',
      cards: {
        above: 'Deviations above',
        aboveUnit: 'meters',
        below: 'Deviations below',
        belowUnit: 'meters',
      },
      charts: {
        deviationTitle: 'Deviation distribution by meter',
        severityTitle: 'Distribution by severity',
        legendAbove: 'Above the limit',
        legendBelow: 'Below the limit',
      },
      columns: {
        meter: 'Meter',
        deviation: 'Deviation',
        baseline: 'Baseline',
        severity: 'Severity',
      },
    },
    veeExecutionMonitor: {
      title: 'VEE Monitoring — Batch Execution Monitor',
      badge: 'Operation/inquiry',
      empty: 'No executions found.',
      columns: {
        execution: 'Execution',
        group: 'Group',
        status: 'Status',
        volume: 'Volume',
        duration: 'Duration',
        backlog: 'Backlog',
      },
      status: {
        completed: 'Completed',
        running: 'Running',
      },
    },
    balance: {
      title: 'Balance',
      balanceCalculation: 'Balance Calculation',
      balanceSettings: 'Balance Settings',
      publicLighting: 'Public Lighting - IP (kWh)',
      search: 'Search',
      balanceEnergy: 'Balance Energy',
      balanceEnergyChart: 'Balance Energy Chart',
      data: 'Data',
      meterTrafo: 'Transformer Meter',
      energyRequired: 'Energy Required (kWh)',
      energyConsumed: 'Energy Consumed (kWh)',
      energyPublicLightingLabel: 'Public Lighting',
      loss: 'Loss (kWh)',
      lossPercentage: 'Loss %',
      energyPublicLighting: 'Public Lighting Energy (kWh)',
      readingDateTime: 'Reading Date',
      initialReadingDateTime: 'Initial Reading Date',
      finalReadingDateTime: 'Final Reading Date',
      energyInjectedConsumers: 'Energy Injected to Consumers (kWh)',
      energyReverseTransformer: 'Transformer Reverse Energy (kWh)',
      empty: 'Empty for now...',
      results: 'Results',
      transformerName: 'Transformer Name',
      areaName: 'Area Name',
      regionName: 'Region Name',
      placeholders: {
        publicLighting: 'Enter the value',
      },
      errors: {
        loadBalance: 'Error searching balance',
      },
    },
    transformers: {
      title: 'Transformers',
      transformer: 'Transformer',
      startDate: 'Initial Date',
      endDate: 'End Date',
      placeholders: {
        loading: 'Loading...',
        select: 'Select Transformer',
        selectDate: 'Select the date',
      },
      errors: {
        title: 'Error',
        loadTransformers: 'Error loading transformers',
      },
    },
    groupDetails: {
      monthlyQualityParameters: {
        title: 'Monthly DRP/DRC average',
        button: 'Calculate monthly DRP/DRC average',
        dialogTitle: 'Monthly DRP/DRC average',
        success: 'Monthly DRP/DRC average calculated successfully',
        error: 'Error calculating the monthly DRP/DRC average',
        exportError: 'Select a reference to export the monthly DRP/DRC average.',
      },
      latestQualityParameters: {
        title: 'Latest quality parameters',
        error: 'Error loading the latest quality parameters',
      },
    },
    scheduledCommands: {
      title: 'Routine Listing',
      filterByGroup: 'Filter by Group name',
      statusChanged: 'Schedule status changed',
      deleteSuccess: 'Schedule deleted successfully',
      timeMax: 'Maximum time to execute the command',
      description: 'Description',
      selectGroup: 'Select group',
      selectCommand: 'Select command',
      editRoutine: 'Edit Routine',
      addRoutine: 'Add Routine',
      configure: 'Configure',
      review: 'Review',
      quantityLastMeasures: 'Quantity of Last Measurements',
      quantityLastMeasuresSmc: 'Quantity of Last Measurements (SMC)',
      commandParameters: 'Command Parameters',
      alternativeDataSmi: 'Alternative Data (SMI)',
      energyRecoveryDataSmi: 'Energy Recovery Data (SMI)',
      initialDateTime: 'Initial Date/Time',
      finalDateTime: 'Final Date/Time',
      intervalMinutes: 'Interval in Minutes',
      seconds: 'Seconds',
      back: 'Back',
      update: 'Update',
      add: 'Add',
      routineUpdated: 'Routine Updated',
      routineCreated: 'Routine Created',
      saveRoutineError: 'Error saving Routine',
      unknownError: 'Unknown error',
      loadGroupsError: 'Error loading groups',
      successTitle: 'Success',
      errorTitle: 'Error',
      statusChangeError: 'Error changing schedule status',
      deleteRoutineError: 'Error deleting schedule',
      minuteUnit: 'minute',
      minutesUnit: 'minutes',
      placeholders: {
        filterByGroup: 'Enter the Group name',
        description: 'Enter a description for the routine',
        selectGroup: 'Select a group',
        selectCommand: 'Select a command',
        quantity: 'Enter the quantity',
        initialDate: 'Select the initial date',
        finalDate: 'Select the final date',
        interval: 'Enter the interval',
        secondsQuantity: 'Enter the number of seconds',
      },
      days: 'Day(s)',
      hours: 'Hour(s)',
      minutes: 'Minute(s)',
      cronEditor: 'Cron Editor',
      validation: {
        descriptionRequired: 'Enter the routine description.',
        descriptionHtmlNotAllowed: 'The routine description cannot contain HTML.',
        groupRequired: 'Select a group.',
        minimumDuration: 'The maximum time to execute the command must be at least 1 minute.',
        invalidCron: 'Configure a valid cron for the routine.',
      },
      cronEditorOptions: {
        intlLocale: 'en-US',
        every: 'Every',
        second: 'Second',
        minute: 'Minute',
        hour: 'Hour',
        day: 'Day',
        week: 'Week',
        month: 'Month',
        year: 'Year',
        everySecond: 'every second',
        everyMinute: 'every minute',
        everyHour: 'every hour',
        everyMonth: 'every month',
        everyDayOfWeek: 'every specific day of week',
        noSpecificDay: 'no specific day',
        noSpecificDayOfWeek: 'no specific day of the week',
        all: 'all',
        of: 'of',
        onDays: 'on day(s)',
        and: 'and',
        andOf: 'and of',
        at: 'at',
        secondsSuffix: 'second(s)',
      },
      nextExecution: 'Next execution',
      lastExecution: 'Last execution',
      routineDetails: 'Routine Details',
      routinePage: 'Routine Page',
      deleteRoutine: 'Delete Routine',
      noProcessYet: 'No process found for this routine yet.',
    },
    transformerDetails: {
      title: 'Transformer Details',
      details: 'Details',
      transformer: 'Transformer',
      editTransformer: 'Edit Transformer',
      name: 'Name',
      meterSerial: 'Meter Serial',
      metersCount: 'Meters Count',
      publicLighting: 'Public Lighting',
      coordinates: 'Coordinates',
      updatedAt: 'Updated At',
      description: 'Description',
      viewMore: 'View More',
      meterDetails: 'Meter Details',
      manufacturerType: 'Manufacturer | Type',
      serial: 'Serial',
      installation: 'Installation',
      displayConfiguration: 'Display Configuration',
      firmware: 'Firmware',
      relayStatus: 'Relay Status',
      status: 'Status',
      meterMoreDetails: 'Meter Details',
      latitude: 'Lat',
      longitude: 'Long',
      massMemoryCrc: 'CRC Mass Memory',
      uplinkPeriod: 'Uplink Period',
      energyCrc: 'CRC Energy',
      tags: 'Meter Tags',
      noTags: 'No tags found',
      close: 'Close',
      loading: 'Loading...',
    },
    areas: {
      title: 'Areas',
      startDate: 'Initial Date',
      endDate: 'End Date',
      search: 'Search',
      placeholders: {
        loading: 'Loading...',
        select: 'Select Area',
        selectDate: 'Select the date',
      },
      errors: {
        title: 'Error',
        loadAreas: 'Error loading areas',
      },
    },
    areaDetails: {
      title: 'Area Details',
      details: 'Details',
      area: 'Area',
      editArea: 'Edit Area',
      name: 'Name',
      transformersCount: 'Transformers Count',
      updatedAt: 'Updated At',
      description: 'Description',
      errors: {
        title: 'Error',
        loadAreaInfo: 'Error loading area information',
      },
    },
    regions: {
      title: 'Regions',
      regions: 'Regions',
      selectPeriod: 'Select the period',
      startDate: 'Initial Date',
      endDate: 'End Date',
      search: 'Search',
      placeholders: {
        loading: 'Loading...',
        select: 'Select Region',
        selectDate: 'Select the date',
      },
      errors: {
        title: 'Error',
        loadRegions: 'Error loading regions',
      },
    },
    regionDetails: {
      title: 'Region Details',
      details: 'Details',
      region: 'Region',
      editRegion: 'Edit Region',
      name: 'Name',
      areasCount: 'Areas Count',
      updatedAt: 'Updated At',
      description: 'Description',
      errors: {
        title: 'Error',
        loadRegionInfo: 'Error loading region information',
      },
    },
    serviceNotes: {
      code: 'Code',
      contractAccount: 'Contract Account',
      dateTimeLimitConclusion: 'Deadline for Completion',
      dateTimeStart: 'Start Date',
      codeGroup: 'Code Group',
      installation: 'Installation',
      measureCodeGroup: 'Measurement Code Group',
      noteNumber: 'Note Number',
      equipmentSerialNumber: 'Equipment Serial Number',
      cancellationRequest: 'Cancellation Request',
      noteType: 'Note Type',
      cPNumber: 'CP Number',
      cSNumber: 'CS Number',
      cSPosition: 'CS Position',
      noteGroup: 'Note Group',
      noteCode: 'Note Code',
      measureGroup: 'Measurement Group',
      equipment: 'Equipment',
      referenceMonth: 'Reference Month',
      creationDate: 'Creation Date',
      creationHour: 'Creation Time',
      limitDate: 'Limit Date',
      limitHour: 'Limit Time',
      serialMeter: 'Meter Serial Number',
      rateType: 'Rate Type',
      ssn: 'SSN',
      min: 'MIN',
      readingDate: 'Reading Date',
      readingUnit: 'Reading Unit',
      day: 'Day',
      serial: 'Serial',
      registers: 'Registers',
      attempts: 'Attempts',
      origin: 'Origin',
      datetime: 'Date',
      online: 'Status',
      meterActivated: 'Relay State',
      comissioned: 'Commissioned',
      dateTimeInitial: 'Start Date',
      dateTimeFinal: 'End Date',
      drp: 'DRP',
      drc: 'DRC',
      updatedAt: 'Updated At',
      count: 'Count',
      description: 'Description',
    },
    models: {
      title: 'Models',
      meterModels: 'Meter Models',
      smcModels: 'SMC Models',
      newModel: 'New Model',
      registerModelFile: 'Import models from file',
      editModelFile: 'Edit models from file',
      import: {
        successAll: 'Import completed successfully',
        partial: 'Import partially completed',
        error: 'Error importing models',
      },
      edit: {
        successAll: 'Edit completed successfully',
        partial: 'Edit partially completed',
        error: 'Error editing models',
      },
      success: {
        createModel: 'Model created successfully',
        updateModel: 'Model updated successfully',
      },
      errors: {
        title: 'Error',
        loadModels: 'Error while fetching models',
        noModelSelected: 'No model selected',
        manufacturerNotFound: 'Manufacturer not found',
        createModel: 'Error while creating model',
        updateModel: 'Error while updating model',
      },
    },
    configuration: {
      title: 'Settings',
      configure: 'Configure',
      effectiveness: {
        title: 'Effectiveness',
        description: 'Configure the minimum number of meters for effectiveness calculation.',
        dialog: {
          title: 'Effectiveness Configuration',
          minimumQuantity: 'Minimum Quantity',
          loading: 'Loading...',
          cancel: 'Cancel',
          save: 'Save',
        },
      },
      abruptVariation: {
        title: 'Abrupt Variation',
        description: 'Configure the parameters for abrupt consumption variation detection.',
      },
    },
  },
  auth: {
    login: {
      title: 'System Access',
      tabEmail: 'E-mail',
      tabLdap: 'AD',
      emailLabel: 'E-mail',
      usernameLdapLabel: 'Network user',
      usernameLdapPlaceholder: 'Enter your network user',
      associate: 'Associate',
      associateWarn:
        'We’ve verified that you’re not yet linked in the system. Please add your email address.',
      passwordLabel: 'Password',
      submitButton: 'Enter locally',
      submitButtonAd: 'Sign in via Active Directory',
      forgotPassword: 'Expired password?',
      placeholders: {
        email: 'Enter your email',
        password: 'Enter your password',
      },
      validation: {
        invalidEmail: 'Invalid email',
        adCredentialRequired: 'Network user or email is required',
        passwordRequired: 'Password is required',
      },
    },
    userType: {
      admin: 'Administrator',
      operator: 'Technical Operator',
      user: 'User',
      erector: 'Installer',
      manager: 'Technical Manager',
      sap: 'SAP User',
      monitor: 'Monitor',
      invalid: 'Invalid',
      root: 'Root',
    },
    errors: {
      invalidCredentials: 'Invalid email or password',
      missingFields: 'All fields must be filled',
    },
    requiredChangePassword: {
      title: 'Required Password Change',
      emailLabel: 'E-mail',
      expiredPasswordLabel: 'Current password',
      newPasswordLabel: 'New password',
      submitButton: 'Change Password',
      instructions: 'Change the password created by the administrator.',
      passwordRequirements:
        'The password must contain at least 8 characters, one uppercase letter, one lowercase letter, one number and one special character.',
      placeholders: {
        email: 'Enter your email',
        expiredPassword: 'Enter the current password',
        newPassword: 'Enter your new password',
      },
      messages: {
        successSummary: 'Password Changed Successfully',
        successDetail: 'Next time, log in with your email and new password',
        errorSummary: 'Error',
        errorDetail: 'Error changing password',
      },
      validation: {
        emailRequired: 'Email is required',
        expiredPasswordRequired: 'Current password is required',
        newPasswordMinLength: 'Password must have at least 8 characters',
        newPasswordUppercase: 'Password must contain at least one uppercase letter',
        newPasswordLowercase: 'Password must contain at least one lowercase letter',
        newPasswordNumber: 'Password must contain at least one number',
        newPasswordSpecial: 'Password must contain at least one special character',
        uppercase: 'Uppercase and lowercase letters [A-Z]',
        lowercase: 'Lowercase letters [a-z]',
        number: 'Numbers [0-9]',
        special: 'Special characters [!,@,#,$,%,^,&,* or *]',
        minLength: 'Minimum 8 characters',
      },
    },
  },
  forms: {
    firmware: {
      title: 'Firmware Version',
      detailsFirmware: 'Details of Firmware: ',
      crcHexInfo: 'Hex value in decimal: ',
      fields: {
        crc: 'CRC (Hex or Decimal)',
        firmwareForSMC: 'Firmware for SMC',
        nameFirmware: 'Version name:',
        manufacturer: 'Manufacturer:',
      },
      validation: {
        crcRequired: 'CRC is required',
        crcPrefixError: 'Remove the 0x or space before the hexadecimal number',
        crcInvalidError: 'Invalid value. Enter only decimal or hexadecimal numbers (0-9, A-F)',
        crcImmutableInfo: 'The CRC cannot be changed after creation',
        nameFirmwareRequired: 'Version name is required',
        manufacturerRequired: 'Manufacturer is required',
      },
      actions: {
        registerFirmware: 'Register',
        editFirmware: 'Edit firmware',
        deleteFirmware: 'Delete firmware',
        deleteConfirmationTitle: 'Confirm deletion of firmware in bulk',
        cancel: 'Cancel',
      },
      placeholder: {
        crc: 'Enter the CRC',
        nameFirmware: 'Enter the version name',
        selectManufacturer: 'Select a manufacturer',
        loadingManufacturers: 'Loading manufacturers...',
      },
    },
    keys: {
      title: 'Register key',
      titleEdit: 'Modify Key',
      fields: {
        serial: 'Serial',
        authenticationKey: 'Authentication Key',
        encryptionKey: 'Encryption Key',
        masterKey: 'Master Key',
        lls2: 'LLS2',
      },
      validation: {
        fieldRequired: 'This field is required!',
        serialImmutableInfo: 'The Serial cannot be changed after creation',
        keySize: 'This field must contain 32 characters.',
        lls2Size: 'This field must contain 16 (gateway) or 20 (meter) characters.',
      },
      actions: {
        cancel: 'Cancel',
        create: 'Register',
        update: 'Update',
        save: 'Save',
      },
    },
    tags: {
      title: 'New Tag',
      titleDetails: 'Tag Details: ',
      fields: {
        name: 'Name',
        colors: 'Colors',
      },
      actions: {
        create: 'Create tag',
        update: 'Edit tag',
        delete: 'Delete tag',
        cancel: 'Cancel',
        deleteConfirmationTitle: 'Confirm deletion of tag in bulk',
      },
      validation: {
        fieldRequired: 'This field is required!',
      },
    },
    smcs: {
      title: 'Register new SMC',
      titleEdit: 'Edit SMC',
      fields: {
        serial: 'SMC Serial',
        description: 'Description',
        manufacturer: 'Manufacturer',
        model: 'Model',
        latitude: 'Latitude',
        longitude: 'Longitude',
      },
      validation: {
        serialRequired: 'Serial is required',
        serialNoSpaces:
          'The SMC serial cannot contain spaces at the beginning, in the middle, or at the end.',
        descriptionRequired: 'Description is required',
        manufacturerRequired: 'Manufacturer is required',
        modelRequired: 'Model is required',
        warningDialogTittle: 'Are you sure you want to mark the selected alarms as read?',
        warningDialogMessage:
          "Upon confirmation, a ticket will be automatically generated containing the responsible user's information for historical records.",
        warningDialogTittleSingle: 'Are you sure you want to mark this alarm as read?',
      },
      actions: {
        cancel: 'Cancel',
        create: 'Create SMC',
        update: 'Update',
        confirm: 'Confirm',
      },
      placeholders: {
        serial: 'Enter SMC serial',
        description: 'Enter SMC description',
        manufacturer: 'Enter manufacturer name',
        model: 'Select model',
        latitude: 'Enter latitude',
        longitude: 'Enter longitude',
      },
    },
    clients: {
      title: 'Register new client',
      titleEdit: 'Edit client',
      fields: {
        fullName: 'Full name',
        location: 'Location',
        weights: 'Weights',
        prefixUf: 'UF Prefix',
        selectAvailableMeters: 'Select Available Meters',
      },
      validation: {
        fullNameRequired: 'Full name is required',
        locationRequired: 'Location is required.',
        weightsInvalidFormat:
          'Enter weights with a single digit per position, separated by comma, space, or semicolon.',
        weightsInvalidLength: 'Invalid weights count. Accepted values: 6, 7, or 10 digits.',
        prefixUfRequired: 'UF Prefix is required.',
        prefixUfInvalid: 'Enter a valid UF Prefix.',
      },
      actions: {
        cancel: 'Cancel',
        create: 'Register',
        update: 'Update',
      },
    },
    tariffs: {
      dateStart: 'Initial Date',
      select: 'Select Tariff Type',
      dateActivation: 'Activation Date',
      send: 'Send',
    },
    models: {
      title: 'Register new model',
      titleEdit: 'Edit model',
      fields: {
        name: 'Name',
        manufacturer: 'Manufacturer',
        positionsCount: 'Positions count',
      },
      validation: {
        nameRequired: 'Name is required',
        manufacturerRequired: 'Manufacturer is required',
      },
      actions: {
        cancel: 'Cancel',
        create: 'Create',
        update: 'Save',
      },
      placeholder: {
        name: 'Enter the model name',
        selectManufacturer: 'Select the manufacturer',
        loadingManufacturers: 'Loading manufacturers...',
        positionsCount: 'Positions count',
      },
    },
  },
  tables: {
    noData: 'No data found',
    general: {
      search: 'Quick Search',
      status: 'Status',
      period: 'Period',
      dateRange: 'Date Range',
      dateRangeError: 'Select start and end dates.',
      quickOptions: 'Quick options',
      quickOptionsHint: 'select a suggested period',
      commands: 'Commands',
      searchByEmail: 'Search by email:',
      searchBySerial: 'Search by serial:',
      selectColumns: 'Select columns:',
      commandsSelectionLimitSummary: 'Selection limit',
      commandsSelectionLimitDetail: 'You can select up to 5 commands.',
      commandsSelectionRequiredSummary: 'Warning',
      commandsSelectionRequiredDetail: 'Select at least one command.',
      selectStatus: 'Select status:',
      searchByText: 'Search by text:',
      commissioning: 'Commissioning:',
      gatewayName: 'Gateway Name:',
      gatewaySerial: 'Gateway Serial:',
      typeSignalQuality: 'Signal Type:',
      type: 'Type:',
      details: 'Details',
      tags: 'Tags',
      selectTags: 'Select tags',
      selectOption: 'Select an option',
      all: 'All',
      error: 'Error',
      totalRecords: 'Total records: {totalRecords}',
      yes: 'Yes',
      no: 'No',
      placeholders: {
        searchByText: 'Search here',
        gatewayName: 'Gateway Name',
        gatewaySerial: 'Gateway Serial',
        commissioning: 'Select commissioning',
        period: 'Select period',
        type: 'Select type',
        typeSignalQuality: 'Select signal type',
        selectColumns: 'Select columns',
      },
      tableChart: {
        showAll: 'Show all',
        showLess: 'Show less',
        displayedColumns: 'Displayed columns:',
        monoChartDisplayedColumns: 'Charts:',
      },
    },
    meterFileUpload: {
      massMemory: {
        dateTime: 'Reading date/time',
        totalEnergy_Wh: 'General totalizer (Wh)',
        totalEnergyIncremental_Wh: 'Incremental totalizer (Wh)',
        q1ReactiveEnergy_VarH: 'Reactive energy Q1 (VarH)',
        q4ReactiveEnergy_VarH: 'Reactive energy Q4 (VarH)',
        group2VoltageVaH_V: 'Voltage Va (V)',
        group2VoltageVbH_V: 'Voltage Vb (V)',
        group2VoltageVcH_V: 'Voltage Vc (V)',
        group3CurrentIaH_A: 'Current Ia (A)',
        group3CurrentIbH_A: 'Current Ib (A)',
        group3CurrentIcH_A: 'Current Ic (A)',
        totalActiveEnergy_KWh: 'Total active energy (kWh)',
        totalInductiveReactiveEnergy_KVarh: 'Total inductive reactive energy (kvarh)',
        totalCapacitiveReactiveEnergy_KVarh: 'Total capacitive reactive energy (kvarh)',
        totalReverseActiveEnergy_KWh: 'Total reverse active energy (kWh)',
        reactiveEnergyImportQiiiRi_KVarH: 'Reactive energy import Q3 +Ri (kvarh)',
        reactiveEnergyImportQiiRc_KVarH: 'Reactive energy import Q2 +Rc (kvarh)',
        q1ReactiveEnergyIncremental_VarH: 'Reactive energy Q1 incremental (kWh)',
        q4ReactiveEnergyIncremental_VarH: 'Reactive energy Q4 incremental (kWh)',
        totalActiveEnergy_Wh: 'Direct active energy (kWh)',
        totalDirectActiveEnergy_Wh: 'Total direct active energy (kWh)',
        borderTotalizer_Wh: 'Peak totalizer (kWh)',
        reservedTotalizer_Wh: 'Off-peak totalizer (kWh)',
        offBorderTotalizer_Wh: 'Reserved totalizer (kWh)',
        totalIntermediary_Wh: 'Intermediary total (kWh)',
        generatedEnergyTotal_Wh: 'Generated energy - total (kWh)',
        totalReverseActiveEnergy_Wh: 'Total reverse active energy (kWh)',
        totalDemand_W: 'Total active demand (W)',
        borderDemand_W: 'Peak active demand (W)',
        reservedDemand_W: 'Off-peak active demand (W)',
        totalApparentDemand_Va: 'Total apparent demand (VA)',
        borderApparentDemand_Va: 'Peak apparent demand (VA)',
        reservedApparentDemand_Va: 'Off-peak apparent demand (VA)',
        totalDemandIncremental_W: 'Total active demand incremental (W)',
        borderDemandIncremental_W: 'Peak active demand incremental (W)',
        reservedDemandIncremental_W: 'Off-peak active demand incremental (W)',
        demandResetCount: 'Demand reset count',
        demandResetTime: 'Demand reset time',
        demandResetTimeMs: 'Demand reset time (ms)',
        demandCurrentTime: 'Current demand time',
        demandCurrentTimeMs: 'Current demand time (ms)',
        voltageA: 'Voltage A (V)',
        voltageB: 'Voltage B (V)',
        voltageC: 'Voltage C (V)',
        currentA: 'Current A (A)',
        currentB: 'Current B (A)',
        currentC: 'Current C (A)',
        maximumCurrentA_A: 'Maximum current A (A)',
        activePowerA: 'Active power A (W)',
        activePowerB: 'Active power B (W)',
        activePowerC: 'Active power C (W)',
        lastAverageVoltageL1_V: 'Average voltage L1 (V)',
        lastAverageCurrentL1_A: 'Average current L1 (A)',
        lastAverageVoltageL2_V: 'Average voltage L2 (V)',
        lastAverageCurrentL2_A: 'Average current L2 (A)',
        lastAverageVoltageL3_V: 'Average voltage L3 (V)',
        lastAverageCurrentL3_A: 'Average current L3 (A)',
        totalPowerFactor_NoUnit: 'Total power factor',
      },
      quality: {
        dateTimeInitial: 'Initial date/time',
        dateTimeFinal: 'Final date/time',
        description: 'Description',
        drp: 'DRP (%)',
        drc: 'DRC (%)',
        dtt95: 'DTT95 (%)',
        fd95: 'FD95 (%)',
      },
      energy: {
        dateTime: 'Date/time',
        totalEnergy_Wh: 'Total active energy (Wh)',
        borderTotalizer_Wh: 'Peak totalizer (Wh)',
        reservedTotalizer_Wh: 'Reserved totalizer (Wh)',
        offBorderTotalizer_Wh: 'Off-peak totalizer (Wh)',
        totalIntermediary_Wh: 'Intermediary totalizer (Wh)',
        generatedEnergyTotal_Wh: 'Generated energy total (Wh)',
        totalReverseActiveEnergy_Wh: 'Total reverse active energy (kWh)',
        totalInductiveReactiveEnergy_VarH: 'Total inductive reactive (VarH)',
        totalCapacitiveReactiveEnergy_VarH: 'Total capacitive reactive (VarH)',
        consumedMaximunDemand_W: 'Maximum consumed demand (W)',
        injectedMaximunDemand_W: 'Maximum injected demand (W)',
        positiveReactiveEnergy_Wh: 'Positive reactive energy (kWh)',
        negativeReactiveEnergy_Wh: 'Negative reactive energy (kWh)',
        forderTotalizer_Wh: 'Direct active energy T1 (kWh)',
        generatedOffBorderEnergyTotal_Wh: 'Generated off-peak active energy (kWh)',
        generatedIntermediaryEnergyTotal_Wh: 'Generated intermediary active energy (kWh)',
        generatedBorderEnergyTotal_Wh: 'Generated peak active energy (kWh)',
        generatedReservedEnergyTotal_Wh: 'Generated reserved active energy (kWh)',
      },
      alarms: {
        dateEvent: 'Event date',
        description: 'Description',
        serial: 'Serial',
        installation: 'Installation',
        terminal: 'Terminal',
      },
    },
    meters: {
      title: 'Meters',
      importMeters: 'Import Meters',
      editMeters: 'Edit Meters',
      linkTags: 'Link Tags',
      unlinkTags: 'Unlink Tags',
      commissioning: 'Commissioning',
      serial: 'Serial',
      installation: 'Installation',
      modemSignalQuality: 'Signal',
      accountantStatus: 'Status',
      updatedAt: 'Updated At',
      readingsCount: 'Readings Count',
      totalOfSent: 'Total of Sent',
      successOfSent: 'Success of Sent',
      failOfSent: 'Fail of Sent',
      deviceEui: 'Device Eui',
      meterPhase: 'Phase',
      manufacturer: 'Manufacturer',
      position: 'Position',
      commands: 'Commands',
      tags: 'Tags',
      firmware: 'Firmware',
      phase: 'Phase',
      communication: 'Communication',
      status: 'Status',
    },
    smcs: {
      title: 'Smcs',
      serial: 'Serial',
      qtyMeters: 'Quantity',
      firmware: 'Firmware',
      comissioned: 'Commissioned',
      doorStatus: 'Door',
      online: 'Communication Status',
      smcModel: 'Model',
      signalQuality: 'Signal',
      updatedAt: 'Updated At',
    },
    alarms: {
      title: 'Alarms',
      serial: 'Serial',
      description: 'Description',
      dateTime: 'Date and Time',
      alarmType: 'Alarm Type',
      selectAlarmType: 'Select alarm type',
      terminal: 'Terminal',
      updatedAt: 'Updated At',
      isCritical: 'Critical Alarm',
      errors: {
        error: 'Error',
        incompleteMeterData: 'Incomplete meter data for export',
      },
    },
    smcAlarms: {
      title: 'Alarms of SMC',
      readDateTime: 'Reading Date and Time',
      description: 'Description',
      updatedAt: 'Last Update',
    },
    meterAlarms: {
      title: 'Alarms of Meters',
      readDateTime: 'Reading Date and Time',
      description: 'Description',
      updatedAt: 'Last Update',
      serial: 'Serial',
      terminal: 'Terminal',
    },
    alarmTypesMeter: {
      title: 'SMI/SMC Meter Events Table',
      description: 'Description',
      count: 'Count',
      wasRead: 'Reading Status',
      read: 'Read',
      unread: 'Unread',
      errorSearch: 'Error fetching alarm types',
    },
    alarmTypesSmc: {
      title: 'SMC Events Table',
      description: 'Description',
      count: 'Count',
      wasRead: 'Reading Status',
      read: 'Read',
      unread: 'Unread',
      errorSearch: 'Error fetching alarm types',
    },
    tickets: {
      title: 'Tickets',
      serial: 'Serial',
      commandType: 'Command',
      ticketStatus: 'Status of Ticket',
      selectTicketStatus: 'Select the status of the ticket',
      generatedBySystem: 'Generated by the system',
      statusCommand: 'Status of Command',
      lastUpdate: 'Last Update',
      initialDate: 'Initial Date',
      updatedAt: 'Updated At',
      serialMeter: 'Serial Meter',
      user: 'User',
      scheduledTickets: 'Scheduled Tickets',
      scheduledDate: 'Scheduled Date',
      company: 'Company',
      manufacturer: 'Manufacturer',
      deadline: 'Deadline',
      startDate: 'Start Date',
      trackingCode: 'Tracking Code',
      serviceType: 'Service Type',
      status: 'Status of SAP',
      commandTicket: {
        commandId: 'Command ID',
        commandType: 'Command Type',
        initialDate: 'Initial Date',
        finishDate: 'Finish Date',
        attempt: 'Attempt',
        messageSent: 'Message Sent',
        messageReceived: 'Message Received',
        messageError: 'Message Error',
        messageSuccess: 'Message Success',
        noResponse: 'No response',
        totalData: 'Total Data',
        saved: 'Saved',
        failedProcesses: 'Failed Processes',
        answerColumns: {
          answer: 'Answer',
          lineNumber: 'Line',
          operation: 'Operation',
          success: 'Success',
          message: 'Message',
          processedAt: 'Processed At',
          position: 'Answer Position',
          totalEnergy: 'Answer Total Energy',
          relayStatus: 'Answer Relay Status',
          accountantStatus: 'Relay status',
          serial: 'Serial',
          datetime: 'Date/Time',
          group2VoltageVaH_V: 'Voltage VaH(V)',
          group3CurrentIaH_A: 'Current IaH(A)',
          group2VoltageVbH_V: 'Voltage VbH(V)',
          group3CurrentIbH_A: 'Current IbH(A)',
          group2VoltageVcH_V: 'Voltage VcH(V)',
          group3CurrentIcH_A: 'Current IcH(A)',
          group4AngleUiA_deg: 'Angle UiA (º)',
          group4AngleUiB_deg: 'Angle UiB (º)',
          group4AngleUiC_deg: 'Angle UiC (º)',
          index: 'Index',
          specialDayDate: 'Special day date',
          dayOfWeek: 'Day of week',
          dayId: 'Day ID',
          meterId: 'Meter ID',
          type: 'Type',
          name: 'Name',
          description: 'Description',
          time: 'Time',
          tariffType: 'Tariff type',
          dailyTariffs: 'Daily tariffs',
          hourlyTariffs: 'Hourly tariffs',
          drmcDailyTariffs: 'DMCR daily tariffs',
          drmcHourlyTariff: 'DMCR hourly tariffs',
          dmcrType: 'DMCR type',
          hourlyDMCRs: 'Hourly DMCRs',
          meterProfileId: 'Meter profile ID',
          meterDMCRProfileId: 'Meter DMCR profile ID',
          startDate: 'Start date',
          endDate: 'End date',
          deviation: 'Deviation',
          isEnable: 'Enabled',
          enabled: 'Enabled',
          saturdayInductive: 'Saturday inductive',
          saturdayCapacitive: 'Saturday capacitive',
          sundayInductive: 'Sunday inductive',
          sundayCapacitive: 'Sunday capacitive',
          workdayInductive: 'Workday inductive',
          workdayCapacitive: 'Workday capacitive',
          holidayInductive: 'Holiday inductive',
          holidayCapacitive: 'Holiday capacitive',
          timeToActivate: 'Time to activate',
          daylightEndDatetime: 'Daylight saving end date/time',
          daylightBeginDatetime: 'Daylight saving start date/time',
        },
      },
    },
    frozenData: {
      title: 'Energy',
    },
    massMemory: {
      title: 'Mass Memory',
    },
    tableFiscalFasional: {
      title: 'Fiscal Page',
    },
    billing: {
      title: 'Billing History',
      billing: 'Billing',
      stageCode: 'Stage',
      stageDay: 'Day',
      dateSent: 'Sent on',
      status: 'Status',
      type: 'Type',
      typeCode: 'Type Code',
      readingDate: 'Reading Date',
      readingValue: 'Reading Value',
    },
    eventLogs: {
      title: 'Event Logs',
      dateTime: 'Date and Time',
      message: 'Message',
      logLevel: 'Log Level',
      logs: {
        critical: 'Critical',
        debug: 'Debug',
        error: 'Error',
        trace: 'Detailed ( Only Debug )',
        warning: 'Warning',
        none: 'No Message',
        information: 'Information',
      },
      errors: {
        getEventLogs: 'Error getting event logs',
        serialRequired: 'Serial is required',
      },
    },
    alarmVoltage: {
      titleShortDuration: 'Short Interruption Duration Alarms',
      titleLongDuration: 'Long Interruption Duration Alarms',
      calculateInterruptionIndicators: 'Calculate Interruption Indicators',
      referenceMonth: 'Reference Month',
      calculate: 'Calculate',
      fic: 'FIC',
      dic: 'DIC',
      hours: 'Hours',
      hundredthHour: 'Hundredths of Hours',
      minutes: 'Minutes',
      ficTooltip: 'Frequency of Individual Interruption by Consumer Unit or Connection Point',
      dicTooltip:
        'Duration of Individual Interruption by Consumer Unit or Connection Point expressed in Hours',
      dicHundredthHourTooltip:
        'Duration of Individual Interruption by Consumer Unit or Connection Point expressed in Hundredths of Hours',
      dateTime: 'Reading Date',
      voltageOut: 'Voltage',
      createdAt: 'Created At',
      dateTimeStart: 'Start Date and Time',
      dateTimeEnd: 'End Date and Time',
      timeVariation: 'Time Variation',
    },
    alarmsMeters: {
      title: 'Alarms of Meters',
    },
    qeeIndicators: {
      title: 'Quality Parameters',
      monthlyAverage: 'Monthly Average',
      recoverQualityParams: 'Recover Quality Parameters',
      calculateMonthlyAverage: 'Calculate Monthly Average',
      dateAndTimeInitial: 'Initial Date',
      dateAndTimeFinal: 'Final Date',
      referenceMonth: 'Month of Reference',
      meterStatus: 'Meter Status',
      onlineStatus: 'Online Status',
      description: 'Description',
      commissioned: 'Commissioned',
      dateTime: 'Fecha y hora',
      drp: 'DRP',
      drc: 'DRC',
      dic: 'DIC',
      fic: 'FIC',
      dmic: 'DMIC',
      dmicOccurrenceTime: 'DMIC Occurrence Time',
      noInformation: 'No Information',
      dialog: {
        referenceMonth: 'Reference Month',
        quantityOfSamples: 'Desired Number of Samples',
        initialDate: 'Set Start Date',
        endDate: 'Set End Date',
        drp: 'DRP',
        drc: 'DRC',
        dtt95: 'DTT95',
        fd95: 'FD95',
        drcPhaseA: 'DRC Phase A',
        drpPhaseA: 'DRP Phase A',
        drcPhaseB: 'DRC Phase B',
        drpPhaseB: 'DRP Phase B',
        drcPhaseC: 'DRC Phase C',
        drpPhaseC: 'DRP Phase C',
        calculate: 'Calculate',
        cancel: 'Cancel',
        request: 'Request',
        requestSentTitle: 'Request Sent',
        requestSentSuccess: 'Monthly average requested successfully',
        requestSentError: 'Could not request Monthly Average',
        relayOff: 'Relay off',
        relayOffDescription: 'Could not request the monthly average for this meter',
        noQualityParametersFound: 'No quality parameters were found for this meter',
      },
      placeholders: {
        referenceMonth: 'Select the reference month',
      },
      errors: {
        incompleteMeterData: 'Incomplete meter data for export',
      },
    },
    instantMeasure: {
      title: 'Instant Measurements',
      requestMeasure: 'Request Measurements',
      readingTime: 'Reading Time',
      voltageVa: 'Voltage Va (V)',
      voltageVb: 'Voltage Vb (V)',
      voltageVc: 'Voltage Vc (V)',
      currentIa: 'Current Ia (A)',
      currentIb: 'Current Ib (A)',
      currentIc: 'Current Ic (A)',
      angleUiA: 'Angle Ui A (º)',
      angleUiB: 'Angle Ui B (º)',
      angleUiC: 'Angle Ui C (º)',
    },
    firmware: {
      lastUpdate: 'Last Update',
      crc: 'CRC',
      name: 'Name',
      manufacturer: 'Manufacturer',
    },
    keys: {
      lastUpdate: 'Last Update',
      serial: 'Serial',
      authenticationKey: 'Authentication Key',
      encryptionKey: 'Encryption Key',
      masterKey: 'Master Key',
      lls2: 'LLS2',
    },
    tags: {
      lastUpdate: 'Last Update',
      tagId: 'Tag ID',
      name: 'Name',
      colorCode: 'Color (Hex Code)',
      colors: 'Colors',
    },
    models: {
      name: 'Name',
      manufacturer: 'Manufacturer',
      positionsCount: 'Positions count',
    },
    clients: {
      title: 'Clients',
      newClient: 'New Client',
      deleteClients: 'Delete Clients',
      name: 'Name',
      location: 'Location',
      statusActive: 'Active',
      quantityMeterSerials: 'Quantity of Meters',
      updatedAt: 'Last update',
      weights: 'Weights',
      prefixUf: 'UF Prefix',
    },
    process: {
      title: 'Processes',
      processId: 'Process ID',
      processType: 'Process Type',
      user: 'User',
    },
    balanceDevices: {
      title: 'Balance of Devices',
      trafo: 'Trafo',
      device: 'Device',
      initialDate: 'Initial Energy Consumption Date',
      initialReading: 'Initial Energy Consumption (kWh)',
      finalDate: 'Final Energy Consumption Date',
      finalReading: 'Final Energy Consumption (kWh)',
      consumption: 'Consumption (kWh)',
      energyInjectedConsumers: 'Injected Energy (kWh)',
      energyReverseTransformer: 'Reverse Energy (kWh)',
    },
    balanceTransformers: {
      title: 'Balance of Transformers',
      date: 'Date',
      nameTrafo: 'Transformer Name',
      trafoMeter: 'Transformer Meter',
      energyRequired: 'Energy Required (kWh)',
      energyConsumed: 'Energy Consumed (kWh)',
      loss: 'Loss (kWh)',
      streetLighting: 'Public Lighting Energy (kWh)',
      lossPercentage: 'Loss %',
    },
    balanceAreasRegions: {
      title: 'Balance of Areas',
      data: 'Data',
      nameArea: 'Area Name',
      energyRequired: 'Energy Required (kWh)',
      energyConsumed: 'Energy Consumed (kWh)',
      loss: 'Loss (kWh)',
      streetLighting: 'Public Lighting Energy (kWh)',
      lossPercentage: 'Loss %',
    },
    transformers: {
      title: 'Transformers',
      newTransformer: 'New Transformer',
      deleteTransformers: 'Delete Transformers',
      name: 'Name',
      description: 'Description',
      publicLighting: 'Public Lighting Monthly (kWh)',
      trafoMeter: 'Transformer Meter',
      connected: 'Connected',
      latLong: 'Lat/Long',
      updatedAt: 'Last Update',
      errorSearch: 'Error searching Transformers',
      noTransformerSelected: 'No transformer selected',
    },
    scheduledCommands: {
      group: 'Group',
      command: 'Command',
      executionTime: 'Execution Time',
      status: 'Status',
      nextExecution: 'Next Execution',
      active: 'Active',
      paused: 'Paused',
      pausedScheduling: 'Paused Scheduling',
      scheduling: 'schedule',
      errorSearch: 'Error fetching schedules',
      noScheduleSelected: 'No schedule selected',
      noSchedule: 'No schedule registered',
      deleteSchedule: 'Schedule Deletion',
      newRoutine: 'Schedule Command',
    },
    lowEffectiveness: {
      title: 'Low Effectiveness Locations',
      locationCode: 'Location Code',
      regionCode: 'Region Code',
      totalMeters: 'Total Meters',
      lowEffectivenessMeters: 'Low Effectiveness Meters',
      lowEffectivenessPercent: 'Low Effectiveness Percentage',
      effectivenessPercent: 'Effectiveness Percentage',
      errorSearch: 'Error searching low effectiveness locations',
    },
    unavailabilityPeak: {
      title: 'Unavailability Peak',
      meter: 'Meter',
      consumerUnit: 'Consumer Unit',
      locationCode: 'Location Code',
      regionCode: 'Region Code',
      manufacturer: 'Manufacturer',
      unavailableDays: 'Unavailable Days',
      totalDays: 'Total Days',
      unavailabilityPercent: 'Unavailability Percentage',
      availabilityPercent: 'Availability Percentage',
      errorSearch: 'Error searching unavailability peaks',
    },
    areas: {
      title: 'Areas',
      newArea: 'New Area',
      name: 'Name',
      description: 'Description',
      transformersCount: 'Transformers Count',
      updatedAt: 'Last Update',
      deleteAreas: 'Delete Areas',
      errors: {
        title: 'Error',
        loadAreaInfo: 'Error loading area information',
        noAreaSelected: 'No area selected',
      },
      areasTransformers: {
        title: 'Transformers of Area',
        manageTransformers: 'Manage Transformers',
        name: 'Name',
        serialMeter: 'Serial Meter',
        metersCount: 'Meters Count',
        publicLighting: 'Public Lighting',
        coordinates: 'Coordinates',
        updatedAt: 'Last Update',
      },
    },
    regions: {
      title: 'Regions',
      newRegion: 'New Region',
      deleteRegions: 'Delete Regions',
      name: 'Name',
      description: 'Description',
      areasCount: 'Areas Count',
      updatedAt: 'Last Update',
      errors: {
        title: 'Error',
        loadRegions: 'Error loading regions',
        noRegionSelected: 'No region selected',
      },
    },
    regionsAreas: {
      title: 'Areas of Region',
      manageAreas: 'Manage Areas',
      name: 'Name',
      description: 'Description',
      transformersCount: 'Transformers Count',
      updatedAt: 'Last Update',
    },
    transformerMeters: {
      title: 'Transformers Meters',
      importMeters: 'Import meters by file',
      removeMeters: 'Remove meters by file',
      manageMeters: 'Manage meters',
      importNameModal: 'meter-model-by-transformer-registration',
      removeNameModal: 'meter-model-by-transformer-removal',
      meter: 'meter(s)',
      success: {
        registerMeters: 'Meters registered successfully',
        removeMeters: 'Meters removed successfully',
      },
      errors: {
        registerMeters: 'Error registering meters',
        removeMeters: 'Error removing meters',
        metersNotRegistered: 'meter(s) could not be registered',
        unknownReason: 'Unknown reason',
      },
      warnings: {
        partialSuccess: 'Partial meter registration',
        metersNotUpdated: 'meter(s) were not updated',
      },
    },
  },
  echarts: {
    noteType: {
      title: 'Service Type',
      services: 'Services',
      regions: 'Regions',
      manufactures: 'Manufacturers',
    },
    sapStatus: {
      title: 'SAP Status',
      services: 'Services',
      regions: 'Regions',
      manufactures: 'Manufacturers',
    },
    requestStatus: {
      title: 'Command Status',
      status: 'Status',
      services: 'Services',
      regions: 'Regions',
      manufactures: 'Manufacturers',
    },
    table: {
      createdAt: 'Created at',
      updatedAt: 'Updated at',
      startDate: 'Start date of execution',
      actionType: 'Action type',
      status: 'Status',
      company: 'Region',
      manufacturer: 'Manufacturer',
      meterSerial: 'Serial',
      trackingCode: 'Tracking',
    },
    effectiveness: {
      title: 'Effectiveness and Availability',
      manufacturers: 'Manufacturers',
      networkTech: 'Network Technology',
      cityOrState: 'City / State',
      cityOrStatePlaceholder: 'Enter city/state name',
      meterRegion: {
        serial: 'Serial',
        regionCode: 'Region Code',
        districtCode: 'District Code',
        sectionCode: 'Section Code',
        locationTypeCode: 'Location Type Code',
        locationCode: 'Location Code',
        fullAddress: 'Full Address',
        city: 'City',
        feeder: 'Feeder',
        districtName: 'District Name',
        neighborhood: 'Neighborhood',
        regional: 'Regional',
        sectional: 'Sectional',
      },
    },
    process: {
      title: 'Status',
      success: 'Success',
      failed: 'Failed',
      waiting: 'Waiting',
      executing: 'Executing',
      scheduled: 'Scheduled',
    },
    status: {
      title: 'Status',
      statusOnline: 'Online',
      statusOffline: 'Offline',
      statusAbsent: 'Absent',
    },
    commission: {
      title: 'Commissioning',
      commissionOn: 'Commissioned',
      commissionOff: 'Not Commissioned',
      commissionOns: 'Commissioned',
      commissionOffs: 'Not Commissioned',
    },
    situation: {
      title: 'Situation',
      disabled: 'Disconnected',
      activated: 'Connected',
      noRelay: 'No Relay',
      noInformation: 'No Information',
      titleNoMeters: 'Table of Situation - Meters',
    },
    billing: {
      title: 'Information about billing',
      status: 'Status',
      success: 'Success',
      noReadings: 'No readings',
      noReadingsDescription: 'No readings available for billing.',
      withReadings: 'With readings',
      withReadingsDescription:
        'There were readings, but an error occurred when sending them to the commercial system.',
      withoutStage: 'Without stage',
      withoutStageDescription: 'There is no billing stage assigned to this meter yet.',
      scheduled: 'Scheduled',
      scheduledDescription: 'Billing scheduled for a future date within the defined period.',
      notStarted: 'Billing not started',
      notStartedDescription: 'The billing date has passed and the process was not executed.',
      successDescription: 'Billing performed successfully, without errors.',
    },
    signalQuality: {
      signal: 'Signal',
      title: 'Signal Quality',
      period: 'Period',
      dateRange: 'Date Range',
      fiveBars: '5 Bars',
      fourBars: '4 Bars',
      threeBars: '3 Bars',
      twoBars: '2 Bars',
      oneBar: '1 Bar',
      unregistered: 'Unregistered',
      metersWith: 'Meters with',
    },
    commandsSent: {
      title: 'Commands Sent',
    },
    statusCommand: {
      title: 'All Commands',
    },
    alarmStatisticMeter: {
      title: 'SMI/SMC Meter Events',
      read: 'Read',
      unread: 'Unread',
    },
    alarmStatisticSmc: {
      title: 'SMC Events',
      read: 'Read',
      unread: 'Unread',
    },
    fiscalPage: {
      title: 'Fiscal Page',
      noData: 'No data available',
      noDataOnInterval: 'There is no data for the selected range',
      noDataChart: 'No data',
      requestFiscalPage: 'Request Fiscal Page',
      value: 'Value',
      phaseA: 'Phase A',
      phaseB: 'Phase B',
      phaseC: 'Phase C',
      packageDate: 'Package Date',
      frequency: 'Frequency (Hz)',
      voltage: 'Voltage (V)',
      angleVI: 'Angle VI (°)',
      angleVoltage: 'Angle Voltage (°)',
      anglePhase: 'Angle Phase (AB/BC/CA °)',
      current: 'Current',
      currentAngle: 'Angle Current (°)',
      activePower: 'Active Power (W)',
      reactivePower: 'Reactive Power (VAR)',
      powerFactor: 'Power Factor',
      legend: {
        angVoltageA: 'Angle Voltage A',
        angVoltageB: 'Angle Voltage B',
        angVoltageC: 'Angle Voltage C',
        angVIA: 'Angle VI A',
        angVIB: 'Angle VI B',
        angVIC: 'Angle VI C',
        angPhaseAB: 'Angle Phase AB',
        angPhaseBC: 'Angle Phase BC',
        angPhaseCA: 'Angle Phase CA',
        angPhaseAC: 'Angle Phase AC',
        currentAngleA: 'Angle Current A',
        currentAngleB: 'Angle Current B',
        currentAngleC: 'Angle Current C',
      },
    },
  },
  notifications: {
    effectiveness: {
      success: {
        updateConfig: 'Effectiveness configuration updated successfully!',
      },
      error: {
        updateConfig: 'Failed to update effectiveness configuration.',
        getConfig: 'Failed to fetch effectiveness configuration.',
      },
    },
    averageVariation: {
      success: {
        updateConfig: 'Configuration updated successfully!',
      },
      error: {
        updateConfig: 'Failed to update configuration.',
        getConfig: 'Failed to fetch configuration.',
      },
    },
    tickets: {
      success: {
        getTickets: 'Tickets searched successfully',
      },
      error: {
        getTickets: 'Error searching Tickets',
      },
    },
    fiscalPage: {
      success: {
        getFiscalPage: 'Fiscal page recovered successfully',
      },
      error: {
        getFiscalPage: 'Error recovering fiscal page',
      },
    },
    recoverEnergy: {
      success: {
        recoverEnergy: 'Energy totals recovered successfully',
      },
      error: {
        recoverEnergy: 'Error recovering energy totals',
      },
    },
  },
  dialogs: {
    deleteMass: {
      title: 'Confirm deletion in bulk',
      message: 'Are you sure you want to delete the selected items?',
      confirmButton: 'Yes, delete',
      cancelButton: 'Cancel',
    },
    recoverByRangeDate: {
      title: 'Send command',
      description: 'Select the date range',
      placeholder: 'Date range',
      confirmButton: 'Request',
      cancelButton: 'Cancel',
    },
    importModal: {
      downloadModel: 'Download Model',
      chooseFile: 'Choose File',
      fileNotSelected: 'File not selected',
      validateFile: 'Validate File',
      importItems: 'Import Items',
      viewValidatedItems: 'View Validated Items',
      viewIgnoredItems: 'View Ignored Items',
      serialWhitespaceError:
        'The serial cannot contain spaces at the beginning, in the middle, or at the end. Invalid rows: {rows}.',
    },
    massTagsToMeters: {
      linkTitle: 'Link Tags',
      unlinkTitle: 'Unlink Tags',
      steps: {
        tags: 'Tags',
        import: 'Import',
      },
      tagsPlaceholder: 'Select tags',
      selectTagsHint: 'Select at least one tag to continue.',
      next: 'Next',
      back: 'Back',
      selectedTagsCount: '{count} tag(s) selected.',
      finishLink: 'Finish linking',
      finishUnlink: 'Finish unlinking',
      noFileSelected: 'No file selected.',
      emptySerialError: 'The file contains rows with an empty Serial field.',
      fileValidatedSuccess: 'File validated successfully',
      fileValidatedWithIgnored:
        'File validated successfully, but {count} invalid row(s) were ignored.',
      fileProcessError: 'Error processing file',
      noValidSerials: 'No valid serial was found in the file.',
      linkError: 'Could not link tags to meters.',
      unlinkError: 'Could not unlink tags from meters.',
      success: {
        linksCreated: '{affectedLinks} link(s) created on {processedMeters} meter(s).',
        linksRemoved: '{affectedLinks} link(s) removed from {processedMeters} meter(s).',
        notFoundSerials: '{count} serial(s) not found.',
        notFoundTagIds: '{count} tag(s) not found.',
      },
    },
    dialogTransformer: {},
    dialogArea: {
      titleNewArea: 'New Area',
      titleEditArea: 'Edit Area',
      name: 'Name',
      fieldRequired: 'This field is required!',
      description: 'Description',
      delete: 'Delete',
      cancel: 'Cancel',
      modify: 'Modify',
      register: 'Register',
      success: {
        title: 'Success',
        createArea: 'Area created successfully!',
        updateArea: 'Area updated successfully!',
      },
      error: {
        title: 'Error',
        createArea: 'Error creating area',
        updateArea: 'Error updating area',
      },
    },
    dialogRegion: {
      editRegion: 'Edit Region',
      createRegion: 'Create Region',
      title: 'Manage transformers of region',
      name: 'Name',
      fieldRequired: 'This field is required!',
      description: 'Description',
      deleteRegion: 'Delete',
      cancel: 'Cancel',
      modify: 'Modify',
      register: 'Register',
      success: {
        title: 'Success',
        createRegion: 'Region created successfully!',
        updateRegion: 'Region updated successfully!',
      },
      error: {
        title: 'Erro',
        createRegion: 'Error creating region',
        updateRegion: 'Error updating region',
      },
    },
    dialogNewEditAreasInRegion: {
      title: 'Manage areas of region',
      areasInRegion: 'Areas of Region',
      total: 'Total',
      availableAreas: 'Available Areas',
      available: 'Available',
      selected: 'Selected',
      removeAreas: 'Remove Areas',
      addAreas: 'Add Areas',
      exit: 'Exit',
      name: 'Name',
      description: 'Description',
      transformersCount: 'Transformers Count',
      updatedAt: 'Last Update',
      success: {
        title: 'Success',
        addAreas: 'Areas added successfully!',
        removeAreas: 'Areas removed successfully!',
      },
      errors: {
        title: 'Error',
        loadAvailableAreas: 'Error loading available areas',
        addAreas: 'Error adding areas to region',
        removeAreas: 'Error removing areas from region',
      },
    },
    dialogNewEditTransformersInArea: {
      title: 'Manage transformers of area',
      transformersInArea: 'Transformers in Area',
      total: 'Total',
      availableTransformers: 'Available Transformers',
      available: 'Available',
      selected: 'Selected',
      removeTransformers: 'Remove Transformers',
      addTransformers: 'Add Transformers',
      exit: 'Exit',
      name: 'Name',
      serialMeter: 'Serial Meter',
      meters: 'Meters',
      updatedAt: 'Last Update',
      success: {
        title: 'Success',
        addTransformers: 'Transformers added successfully!',
        removeTransformers: 'Transformers removed successfully!',
      },
      errors: {
        title: 'Error',
        loadAvailableTransformers: 'Error loading available transformers',
        addTransformers: 'Error adding transformers to area',
        removeTransformers: 'Error removing transformers from area',
      },
    },
    dialogNewEditMetersInTransformer: {
      title: 'Manage meters of transformer',
      registeredMeters: 'Registered Meters',
      availableMeters: 'Available Meters',
      total: 'Total',
      available: 'Available',
      selected: 'Selected',
      removeMeters: 'Remove Meters',
      registerMeters: 'Register Meters',
      exit: 'Exit',
      serialMeter: 'Serial Meter',
      manufacturer: 'Manufacturer',
      phase: 'Phase',
      signalQuality: 'Signal Quality',
      success: {
        title: 'Success',
        registerMeters: 'Meters registered successfully',
        removeMeters: 'Meters removed successfully',
      },
      errors: {
        title: 'Error',
        registerMeters: 'Error registering meters',
        removeMeters: 'Error removing meters',
      },
    },
    dialogNewEditTransformer: {
      editTransformer: 'Edit Transformer',
      registerTransformer: 'Register Transformer',
      requiredField: 'This field is required!',
      requiredFields: 'Fill in all required fields',
      name: 'Name',
      publicLighting: 'Public Lighting Monthly (kWh)',
      latitude: 'Latitude',
      longitude: 'Longitude',
      readingMeter: 'Reading Meter',
      searchPlaceholder: 'Search by name, manufacturer or serial',
      description: 'Description',
      cancel: 'Cancel',
      modify: 'Modify',
      register: 'Register',
      success: {
        title: 'Success',
        createTransformer: 'Transformer created successfully!',
        updateTransformer: 'Transformer updated successfully!',
      },
      errors: {
        title: 'Error',
        createTransformer: 'Error creating transformer',
        updateTransformer: 'Error updating transformer',
      },
    },
    dialogCancelTicket: {
      title: 'Cancel ticket execution',
      message: 'Do you want to cancel this ticket execution?',
      ticketLabel: 'Ticket',
      commandLabel: 'Command',
      close: 'Close',
      cancelTicket: 'Cancel Ticket',
      success: {
        title: 'Success',
        message: 'Cancellation executed successfully!',
      },
      error: {
        title: 'Error',
        message: 'Error canceling ticket',
      },
    },
  },
  general: {
    cancel: 'Cancel',
    save: 'Save',
    search: 'Search',
    selectClient: 'Select a client',
    meter: 'Meter',
    meters: 'Meters',
    serial: 'Serial',
    attention: 'Attention',
    noInformation: 'No Information',
    notAvailable: 'Not Available',
    noDataFound: 'No data found',
    itemsFound: 'items found',
    actionsFile: 'Actions through file',
    consumerUnit: 'Consumer Unit',
    yes: 'Yes',
    no: 'No',
    exit: 'Exit',
    success: 'Success',
    error: 'Error',
    maximizeMap: 'Maximize Map',
    minimizeMap: 'Minimize Map',
    greeting: 'Hello,',
    changingClient: 'Switching client...',
    myAccount: 'My account',
    email: 'E-mail',
    description: 'Description',
    receiveEmails: 'Receive emails',
    edit: 'Edit',
    profileUpdated: 'Profile updated successfully',
    errorUpdatingProfile: 'Error updating profile',
    veeSeverity: {
      info: 'Info',
      issue: 'Warning',
      terminate: 'Critical',
    },
    validation: {
      requiredFields: 'Check the required fields before continuing.',
      meterSerialRequired: 'The meter serial is required.',
      manufacturerRequired: 'Manufacturer is required.',
      phaseRequired: 'Phase is required.',
      meterModelRequired: 'Model is required.',
      meterTypeRequired: 'Meter type is required.',
      rateTypeRequired: 'Rate type is required.',
      installationRequired: 'Installation code is required.',
      connectionPhaseRequired: 'Connection phase is required.',
      serialCannotContainSpaces:
        'The serial cannot contain spaces at the beginning, in the middle, or at the end.',
      meterSerialCannotContainSpaces:
        'The meter serial cannot contain spaces at the beginning, in the middle, or at the end.',
      smcSerialCannotContainSpaces:
        'The SMC serial cannot contain spaces at the beginning, in the middle, or at the end.',
      meterRegistersRequired: 'Registers are required.',
    },
    comissionedType: {
      all: 'All',
      comissioned: 'Comissioned',
      notComissioned: 'Not Comissioned',
      notRegistered: 'Not Registered',
    },
    meterTypes: {
      all: 'All',
      nepen: 'Integration MDX',
      integration: 'Integration',
      integrationDcu: 'Integration Wasion DCU',
    },
    meterActivated: {
      activated: 'Connected',
      notActivated: 'Disconnected',
      deactivateConfirmation: 'Do you want to disconnect this relay?',
      activateConfirmation: 'Do you want to connect this relay?',
      deactivateMessage: 'Relay Disconnected',
      activateMessage: 'Relay Connected',
    },
    doorStatus: {
      authorized: 'Authorized',
      unauthorized: 'Unauthorized',
    },
    communicationStatus: {
      noInformation: 'No information',
      success: 'Success',
      busy: 'Busy',
      communicationFailed: 'Communication Failure',
      online: 'Online',
      waiting: 'Waiting',
      offline: 'Offline',
      pending: 'Pending',
    },
    signalQuality: {
      neverSeen: 'Never Seen',
      veryWeak: 'Very Weak (1 Bar)',
      weak: 'Weak (2 Bars)',
      reasonable: 'Reasonable (3 Bars)',
      strong: 'Strong (4 Bars)',
      excellent: 'Excellent (5 Bars)',
    },
    signalQualityBars: {
      fiveBars: '5 Bars',
      fourBars: '4 Bars',
      threeBars: '3 Bars',
      twoBars: '2 Bars',
      oneBar: '1 Bar',
    },
    signalQualityLabel: {
      neverSeen: 'Never Seen',
      veryWeak: 'Very Weak',
      weak: 'Weak',
      reasonable: 'Reasonable',
      strong: 'Strong',
      excellent: 'Excellent',
    },
    datePickerExecutionFilter: 'Filter by execution start date',
  },
  manufacturerFilter: {
    label: 'Manufacturers',
    placeholder: 'All Manufacturers',
    loading: 'Loading manufacturers...',
  },
  parametrization: {
    parametrization: 'Parameterization',
    manageParams: 'Manage Parameters',
    searchBySerial: 'Search by Serial',
    unity: 'Consumer Unit',
    manufacturer: 'Manufacturer',
    actions: 'Actions',
    commands: {
      timeParams: 'Time-Related Parameters',
      createDataTemplate: 'Create Date Template',
      requestHolidays: 'Request Holidays',
      createHolidayTemplate: 'Create Holiday Template',
      deleteHolidayTemplate: 'Delete Holiday Template',
      activateProfileActivityCalendar: 'Set Profile Status',
      addActivateTime: 'Add Activation Time',
      sendTarrifPassiveCalendar: 'Send Passive Tariff Calendar',
      requestActivateTimeProfilePassiveActivityCalendar: 'Request Passive Calendar Activation Time',
      dmrcParams: 'Electricity-Related Parameters',
      setDmrcActiveStatus: 'Set DMCR Profile Status',
      setDmrcActivateTime: 'Add DMCR Activation Time',
      requestDmrcDayProfilePassive: 'Request DMCR Passive Calendar Activation Time',
      addDmrcDayPassiveCalendar: 'Add DMCR Passive Calendar Day',
      setDmrcSwitch: 'Set DMCR and UFER Switch',
      requestDmrcSwitch: 'Request DMCR and UFER Switch',
      readings: 'Demand-Related Parameters',
      recoverRegisters: 'Retrieve Registers',
      getGeneralReadings: 'Retrieve General Readings',
    },
    daylightSavingTable: 'Registered Schedules',
    finalDate: 'Start Date',
    endDate: 'End Date',
    deviation: 'Deviation (minutes)',
    isEnable: 'Active',
    confirmDelete: 'Confirm Deletion',
    deleteConfirmationMessage: 'Do you really want to delete this schedule?',
    deleteTarrifConfirmationMessage: 'Do you really want to delete this tariff?',
    cancel: 'Cancel',
    delete: 'Delete',
    tarrifsTable: 'Daily Tariffs',
    createDailyTariff: 'Create Daily Tariff',
    day: 'Day',
    name: 'Name',
    description: 'Description',
    meterProfile: 'Meter Profile',
    numberOfSchedules: 'Number of Schedules',
    activateProfileActivityCalendar: 'Set Profile Status',
    serial: 'Serial',
    meter: 'Meter',
    value: 'Value',
    addTimeForActivation: 'Add Activation Time',
    activationDateTime: 'Activation Date and Time',
    save: 'Save',
    createDmrcCalendar: 'Create DMCR Calendar',
    dayId: 'Day ID',
    annualHoliday: 'Annual holiday',
    time: 'Time',
    dmcrType: 'DMCR Type',
    createHolidayTemplate: 'Create Holiday Template',
    deleteHolidayTemplate: 'Delete Holiday Template',
    index: 'Index',
    holidayDate: 'Holiday Date',
    addHoliday: 'Add Holiday',
    addIndex: 'Add Index',
    createDailyTariffTemplate: 'Create Daily Tariff Template',
    hourlyTariffs: 'Hourly Tariffs',
    add: 'Add',
    tariffType: 'Tariff Type',
    createTimePeriodTemplate: 'Create Time Period Template',
    deviationMinutes: 'Deviation (minutes)',
    active: 'Active',
    dmcrSwitchConfiguration: 'DMCR Switch Configuration',
    saturday: 'Saturday',
    sunday: 'Sunday',
    holiday: 'Holiday',
    workday: 'Workday',
    capacitive: 'Capacitive',
    inductive: 'Inductive',
    send: 'Send',
    demandReading: 'Demand Reading',
    demandTypes: 'Demand Types',
    selectDemands: 'Select demands',
    generalReadings: 'General Readings',
    readings: 'Readings',
    selectReadings: 'Select readings',
    sendTariffPassiveCalendar: 'Send Passive Tariff Calendar',
    dailyTariffs: 'Daily Tariffs',
    confirm: 'Confirm',
    startDate: 'Start Date',
    addDmrcActivateTime: 'Add DMCR Activation Time',
    setDmrcActiveStatus: 'Set DMCR Profile Status',
    editDailyTariff: 'Edit Daily Tariff',
    editTimePeriodTemplate: 'Edit Date Template',
    createTimePeriod: {
      title: 'Replace existing record',
      message:
        'This meter already has a configured time period. Would you like to overwrite the current record with the new information?',
    },
  },
  errors: {
    unauthorized: 'You do not have permission to perform this action.',
    notImplemented:
      'Action currently unavailable. This method has not yet been integrated into the system.',
    deviceNotIdentified: 'Device not identified. Check if the serial is registered and try again.',
    generic: 'An error occurred while processing your request.',
  },
  demands: {
    0: 'Total accumulated active imported energy',
    1: 'Accumulated active imported energy (tariff 1)',
    2: 'Accumulated active imported energy (tariff 2)',
    3: 'Accumulated active imported energy (tariff 3)',
    4: 'Accumulated active imported energy (tariff 4)',
    5: 'Total accumulated active exported energy',
    6: 'Accumulated active exported energy (tariff 1)',
    7: 'Accumulated active exported energy (tariff 2)',
    8: 'Accumulated active exported energy (tariff 3)',
    9: 'Accumulated active exported energy (tariff 4)',
    10: 'Current demand of total active imported energy',
    11: 'Current demand of active imported energy (tariff 1)',
    12: 'Current demand of active imported energy (tariff 2)',
    13: 'Current demand of active imported energy (tariff 3)',
    14: 'Current demand of active imported energy (tariff 4)',
    15: 'Current demand of total active exported energy',
    16: 'Current demand of active exported energy (tariff 1)',
    17: 'Current demand of active exported energy (tariff 2)',
    18: 'Current demand of active exported energy (tariff 3)',
    19: 'Current demand of active exported energy (tariff 4)',
    20: 'Maximum demand of total active imported energy',
    21: 'Maximum demand of active imported energy (tariff 1)',
    22: 'Maximum demand of active imported energy (tariff 2)',
    23: 'Maximum demand of active imported energy (tariff 3)',
    24: 'Maximum demand of active imported energy (tariff 4)',
    25: 'Maximum demand of total active exported energy',
    26: 'Maximum demand of active exported energy (tariff 1)',
    27: 'Maximum demand of active exported energy (tariff 2)',
    28: 'Maximum demand of active exported energy (tariff 3)',
    29: 'Maximum demand of active exported energy (tariff 4)',
  },
  generalReadings: {
    0: 'Battery status',
    1: 'Closed billing counter',
    2: 'Direct totalizer - General',
    3: 'Direct totalizer - Peak',
    4: 'Direct totalizer - Off-peak',
    5: 'Direct totalizer - Reserved',
    6: 'Direct totalizer - 4th period',
    7: 'Reverse totalizer - General',
    8: 'Reverse totalizer - Peak',
    9: 'Reverse totalizer - Off-peak',
    10: 'Reverse totalizer - Reserved',
    11: 'Reverse totalizer - Reserved',
    12: 'Reactive inductive direct - General',
    13: 'Reactive inductive direct - Peak',
    14: 'Reactive inductive direct - Off-peak',
    15: 'Reactive inductive direct - Reserved',
    16: 'Reactive inductive direct - 4th period',
    17: 'Reactive capacitive direct - General',
    18: 'Reactive capacitive direct - Peak',
    19: 'Reactive capacitive direct - Off-peak',
    20: 'Reactive capacitive direct - Reserved',
    21: 'Reactive capacitive direct - 4th period',
    22: 'Reactive inductive reverse - General',
    23: 'Reactive inductive reverse - Peak',
    24: 'Reactive inductive reverse - Off-peak',
    25: 'Reactive inductive reverse - Reserved',
    26: 'Reactive inductive reverse - 4th period',
    27: 'Reactive capacitive reverse - General',
    28: 'Reactive capacitive reverse - Peak',
    29: 'Reactive capacitive reverse - Off-peak',
    30: 'Reactive capacitive reverse - Reserved',
    31: 'Reactive capacitive reverse - 4th period',
    32: 'Maximum demand - Direct total',
    33: 'Maximum demand - Direct peak',
    34: 'Maximum demand - Direct off-peak',
    35: 'Maximum demand - Direct reserved',
    36: 'Maximum demand - Direct type D',
    37: 'Accumulated demand - Direct total',
    38: 'Accumulated demand - Direct peak',
    39: 'Accumulated demand - Direct off-peak',
    40: 'Accumulated demand - Direct reserved',
    41: 'Accumulated demand - Direct type D',
    42: 'Maximum demand - Reverse total (peak)',
    43: 'Maximum demand - Reverse peak',
    44: 'Maximum demand - Reverse off-peak',
    45: 'Maximum demand - Reverse reserved',
    46: 'Maximum demand - Reverse type D',
    47: 'Accumulated demand - Reverse total',
    48: 'Accumulated demand - Reverse peak',
    49: 'Accumulated demand - Reverse off-peak',
    50: 'Accumulated demand - Reverse reserved',
    51: 'Accumulated demand - Reverse type D',
    52: 'Total',
    53: 'Peak',
    54: 'Off-peak',
    55: 'Reserved',
    56: 'Peak',
    57: 'Off-peak',
    58: 'Reserved',
    59: 'Peak',
    60: 'Off-peak',
    61: 'Reserved',
  },
  qualityParameters: {
    drpViolationsChartTitle: 'Meters by DRP Violation',
    serial: 'Serial',
    installation: 'Installation',
    selectPeriod: 'Select Period',
    serialPlaceholder: 'Enter meter serial',
    installationPlaceholder: 'Search by installation',
    searching: 'Searching...',
    noResults: 'No results found',
    filters: 'Filters',
    pendencies: 'Pending Issues',
    loading: 'Loading',
    meterWithoutReadings: 'Meters without readings',
    noData: 'No data to be displayed',
    installationsAboveDicLimit: 'Installations above DIC limit',
    installationsAboveFicLimit: 'Installations above FIC limit',
    averageBaseDic: 'Average Base DIC',
    averageBaseFic: 'Average Base FIC',
    badInstalations: 'Installations with Worst Indicators',
    dic: 'DIC',
    fic: 'FIC',
    dicLimit: 'DIC Limit',
    ficLimit: 'FIC Limit',
    ficRegion: 'Region (FIC)',
    status: 'Status',
    drcViolation: 'Meters by DRC Violation',
    tensionVariation: 'Monthly Average Voltage Variation',
    readingsByMonth: 'Readings by Month',
    drpDrcAverage: 'Monthly Average DRP/DRC',
    drpDrcViolations: 'Average DRP/DRC Violation',
    monthlyDicFic: 'Monthly DIC/FIC Value',
    interruptions: 'Power Interruption',
    installationsAboveDrpLimit: 'Installations above DRP limit',
    installationsAboveDrcLimit: 'Installations above DRC limit',
    averageBaseDrp: 'Base Average DRP',
    averageBaseDrc: 'Base Average DRC',
    drp: 'Monthly DRP (%)',
    drc: 'Monthly DRC (%)',
    drpLimit: 'DRP Limit',
    drcLimit: 'DRC Limit',
    drpViolation: 'Monthly DRP Violation (%)',
    drcViolationT: 'Monthly DRC Violation (%)',
    statusGood: 'Good',
    statusAdequate: 'Adequate',
    statusPrecarious: 'Precarious',
    statusCritical: 'Critical',
    drpUpTo20: 'DRP up to 20%',
    drpUpTo40: 'DRP up to 40%',
    drpUpTo60: 'DRP up to 60%',
    drpUpTo80: 'DRP up to 80%',
    drpUpTo100: 'DRP 100%',
    drcUpTo20: 'DRC up to 20%',
    drcUpTo40: 'DRC up to 40%',
    drcUpTo60: 'DRC up to 60%',
    drcUpTo80: 'DRC up to 80%',
    drcUpTo100: 'DRC 100%',
    noInformation: 'No Information',
    selectCategories: 'Select categories',
    state: 'State',
    city: 'City',
    selectState: 'Select state',
    selectCity: 'Select city',
    clear: 'Clear',
    apply: 'Apply',
    averageVoltage: 'Average Voltage',
    readings: 'Readings',
    voltage: 'Voltage',
    viewChart: 'View Chart',
    viewTable: 'View Table',
    exportMonthlySummary: 'Export Monthly Summary',
    byMonth: 'By Month',
    byWeek: 'By Week',
    meters: 'Meters',
    day: 'Day',
    week: 'Week',
    drpPercent: 'DRP %',
    drcPercent: 'DRC %',
    drcViolationPercent: 'DRC VIOLATION %',
    drpViolationPercent: 'DRP VIOLATION %',
    dicHours: 'DIC (Hours)',
    dmicHours: 'DMIC (Hours)',
    drpBand20: 'DRP up to 20%',
    drpBand40: 'DRP up to 40%',
    drpBand60: 'DRP up to 60%',
    drpBand80: 'DRP up to 80%',
    drpBand100: 'DRP 100%',
    drcBand20: 'DRC up to 20%',
    drcBand40: 'DRC up to 40%',
    drcBand60: 'DRC up to 60%',
    drcBand80: 'DRC up to 80%',
    drcBand100: 'DRC 100%',
    averageV: 'Average (V)',
    phaseA: 'Phase A (V)',
    phaseB: 'Phase B (V)',
    phaseC: 'Phase C (V)',
    violationDrc: 'DRC Violation',
    violationDrp: 'DRP Violation',
    totalFicEvents: 'Total FIC (Events)',
    meterQuantity: 'Meter Count',
    dicHoursCompact: 'DIC (Hours)',
    dmicHoursCompact: 'DMIC (Hours)',
    detailedIndicators: 'Detailed Indicators',
    detailedDrpDrcViolations: 'Detailed DRP/DRC Violations',
    detailedDicFic: 'DIC/FIC Details',
    detailedTensionLevels: 'Detailed Voltage Levels',
    averageDrp: 'Average DRP',
    averageDrc: 'Average DRC',
    createdAt: 'Created At',
    manufacturer: 'Manufacturer',
    model: 'Model',
    dateTime: 'Date/Time',
    voltageReading: 'Voltage Reading',
    generalV: 'General (V)',
  },
}
